/**
 * Created by jehe on 07.02.2019.
 */
/*global define, require, $, window, ol*/

/*jslint browser: true*/
import helptext from "./KPhelptextgenerator";
import mapTools from "./js/plugins/mapToolPlugin.js";
import mapWriterPlugin from "./js/plugins/mapWriterPlugin";
import layerspyPlugin from "./js/plugins/layerspyPlugin";
import layerSliderPlugin from "./js/plugins/layerSliderPlugin";
import attribution from "./js/plugins/attributionPlugin";
import layermenu from "./js/plugins/layermenuPlugin";
import baselayerSwitcher from "./js/plugins/baselayerSwitcherPlugin";
import searchPlugin from "./js/plugins/searchPlugin";
import contextPlugin from "./js/plugins/contextMenuPlugin.js";
import topMenuPlugin from "./js/plugins/topMenuToolsPlugin";

import layerImportPlugin from "./js/plugins/layerImportPlugin.js";

("use strict");
var parameters, configs;
//var baseUrl = "//10.192.10.26/";
var baseUrl = "https://od2.pbe.oslo.kommune.no/";
var extraUrl = "https://od2.pbe.oslo.kommune.no/";
((parameters = {
  intranett: true,
  wfsTillegg: "&version=1.1.0&service=wfs&request=GetFeature",
  /** Kart-url'er */
  cacheurl: baseUrl + "tilecache",
  //phpAutocomplete: baseUrl + "php/kartinnsyn/",
  phpAutocomplete: "https://od2.pbe.oslo.kommune.no/noden/",
  //autocompleteUrl: baseUrl + "php/kartinnsyn/getAutocompleteData.php",
  autocompleteUrl:
    "https://od2.pbe.oslo.kommune.no/noden/getAutocompleteDataNoPlan",
  searchUrl: baseUrl + "cgi-bin/wms?map=WFS_SOK",
  kartinnsynurl: baseUrl + "cgi-bin/wms?map=KARTINNSYN",
  //geoJsonWFS: baseUrl + "cgi-bin/wms?map=PIGEOJSON",
  geoJsonWFS: baseUrl + "cgi-bin/wms?map=PI4_GEOJSON",
  tableWfs: baseUrl + "cgi-bin/wms?map=EIENDOM_TABELL&tabell=",
  mapcacheurl: baseUrl + "mapcache/wmts?",
  ki_forgrunnurl: baseUrl + "cgi-bin/wms?map=FORGRUNN",
  kommuneplanurl: baseUrl + "cgi-bin/wms?map=KOMMUNEPLAN",
  vannBekkerEleverurl: baseUrl + "cgi-bin/wms?map=VANN_NY",
  flyfotoUrl: baseUrl + "/cgi-bin/wms?map=FLYFOTO",
  flyfotoTextUrl: baseUrl + "cgi-bin/wms?map=TEKST_FLYFOTO",
  planmetaWSUrl:
    "https://od2.pbe.oslo.kommune.no/noden/Planmetadata/planmetadata?",
  bakgrunnGraaUrl: baseUrl + "cgi-bin/wms?map=BAKGRUNN",
  kpaplankart: baseUrl + "cgi-bin/wms?map=KPA24PLAN",
  kpatemakart: baseUrl + "cgi-bin/wms?map=KPA24TEMA",
  kartlagtURL: baseUrl + "cgi-bin/wms?map=KARTLAGTSKRED",
  grunnforholdURL: baseUrl + "cgi-bin/wms?map=GRUNNFORHOLD",
  avrenningURL: baseUrl + "cgi-bin/wms?map=AVRENNING",
  flomURL: baseUrl + "cgi-bin/wms?map=FLOM",
  luftsone: baseUrl + "cgi-bin/wms?map=LUFTSONE",
}),
  (configs = {
    minZoom: 11,
    mapTools: [
      //Måle areal
      {
        id: "measure-area-small",
        className: "area-btn measure-btn",
        toolTip: "Mål areal",
        buttonText: "Mål areal",
        iconType: "text",
        icon: "m²",
        onclick: "measureAreaClick",
        register: function (registerFunction, callback) {
          mapTools.registerAreaMeasurePlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik måler du",
          id: "measure-area-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene du skal måle mellom.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
            'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      //Måle lengde
      {
        id: "measure-length-small",
        className: "length-btn measure-btn",
        toolTip: "Mål avstand",
        buttonText: "Mål avstand",
        iconType: "icon",
        icon: "icon-measure",
        onclick: "measureLengthClick",
        register: function (registerFunction, callback) {
          mapTools.registerLengthMeasurePlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik måler du",
          id: "measure-length-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene du skal måle mellom.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
            'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      //Tegne
      {
        id: "make-sketch-small",
        className: "sketch-btn",
        toolTip: "Lag tegninger",
        buttonText: "Lag tegninger",
        iconType: "icon",
        icon: "fa fa-pencil",
        onclick: "drawClick",
        register: function (registerFunction, callback) {
          mapTools.registerDrawPlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik tegner du",
          id: "make-sketch-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene i tegningen.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en tegning.",
            'Slett tegningene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      //Zoom helt ut
      {
        id: "zoom-full-small",
        className: "map-eraser-btn",
        toolTip: "Zoom til hele Oslo",
        buttonText: "Zoom helt ut",
        iconType: "icon",
        icon: "glyphicon glyphicon-globe",
        onclick: "zoomFullClick",
      },
      //Fjern markeringer
      {
        id: "map-eraser-small",
        className: "map-eraser-btn",
        toolTip: "Fjern markeringer av eiendommer og planer i kartet",
        buttonText: "Fjern markeringer",
        iconType: "icon",
        icon: "glyphicon glyphicon-erase",
        onclick: "eraserClick",
      },
      //Skrive på kartet
      {
        id: "text-on-map",
        className: "write-btn",
        toolTip: "Skriv på kartet",
        buttonText: "Skriv på kartet",
        iconType: "icon",
        icon: "fa fa-font",
        onclick: "mapWriterClick",
        register: function (registerFunction, callback) {
          mapWriterPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
      //Kikkehull
      {
        id: "layer-spy",
        className: "point-search-btn",
        toolTip: "Se på underliggende kartlag med kikkehullet",
        buttonText: "Kikkehull",
        iconType: "icon",
        icon: "icon-Kikkehull",
        touchSensitive: true,
        onclick: "spyClick",
        parameters: "flyfoto",
        register: function (registerFunction, callback) {
          layerspyPlugin.registerPluginFunction(registerFunction, callback);
        },
        toolHelp: {
          header: "Kikkehull",
          id: "layer-spy-tool-help",
          steps: [
            "Bruk musepekeren til å se på flyfoto under kartet.",
            "Bruk piltast opp eller ned for å gjøre kikkehullet større eller mindre",
          ],
        },
      },
      //Lagslider
      {
        id: "layer-slider",
        className: "slider-btn",
        toolTip:
          "Bruk slideren til å skjule deler av kartlaget eller gjøre det mer gjennomsiktig.",
        buttonText: "Slide",
        iconType: "icon",
        icon: "fa fa-sliders",
        onclick: "mapSliderClick",
        register: function (registerFunction, callback) {
          layerSliderPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
      //Lagimport
      {
        id: "layer-import",
        className: "import-btn",
        toolTip: "Dra og slipp for å importere",
        buttonText: "Import",
        iconType: "icon",
        icon: "fa fa-upload",
        onclick: "importClick",
        register: function (registerFunction, callback) {
          layerImportPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
    ],
    topMenu: [
      /*{
			type: "button",
			id: "planinnsyn-hjelp",
			toolTip: "Åpner hjelpemeny.",
			icon: true,
			iconClass: "icon-Menu",
			innerHTML: "Om tjenesten ",
			onclick: function () {
				$("#share-page").hide(250);
				$("#help-page").toggle(250);
				$(".show-collapsible").removeClass("show-collapsible");
				$("#planinnsyn-hjelp").toggleClass("drop-down-row-active");
				$("#planinnsyn-hjelp").find("i").toggleClass("icon-Menu").toggleClass("icon-Close");
			},
			contentPage: "helpMenu",
		},*/
      /*{
			type: "button",
			id: "planinnsyn-del",
			toolTip: "Del siden, eller lag bokmerke/snarvei.",
			icon: true,
			iconClass: "icon-Del",
			innerHTML: "Del",
			onclick: "shareClick",
			contentPage: "sharePage",
		}*/
    ],
    baseLayers: [
      {
        olType: "group",
        layerId: "baselayers",
        displayInLayerMenu: false,
        layers: [
          {
            olType: "wmts",
            title: "Bakgrunnskart",
            layerId: "bakgrunn",
            url: parameters.mapcacheurl,
            layerName: "bakgrunn_graa",
            visible: false,
            dependent: "text1",
            displayInLayerMenu: false,
            altSource: {
              url: parameters.bakgrunnGraaUrl,
              layerName: "bakgrunn_graa",
            },
          },
          {
            olType: "wmts",
            layerId: "flyfoto",
            title: "Flyfoto",
            url: parameters.mapcacheurl + "map=FLYFOTO",
            layerName: "flyfoto",
            dependent: "text2",
            altSource: {
              url: parameters.flyfotoUrl,
              layerName: "nyeste_flyfoto_bg_hvit",
              epsg: "EPSG:32632",
            },
            displayInLayerMenu: false,
            visible: false,
          },
          {
            olType: "image",
            title: "Gatenavn, adresser, m.m (flyfoto)",
            layerId: "text2",
            url: parameters.flyfotoTextUrl,
            layerName: "forgrunn_tekst",
            zIndex: 100,
            displayInLayerMenu: false,
            visible: false,
          },
          {
            olType: "image",
            title: "Tiltaksflater",
            layerId: "tiltaksflate",
            url: parameters.ki_forgrunnurl,
            zIndex: 200,
            layerName: "Tiltaksflate",
            displayInLayerMenu: false,
            noToggle: true,
            visible: true,
          },
        ],
      },
    ],
    layermenuLayers: [
      {
        olType: "group",
        layerId: "plan_og_byggesak",
        title: "Planer",
        collapsible: true,
        groupCheckbox: false,
        layers: [
          {
            olType: "group",
            title: "Forslag – kommuneplanens arealdel",
            layerId: "kpny",
            layerInfo: false,
            groupCheckbox: true,
            layers: [
              {
                olType: "group",
                title: "Plankart 1 Arealbruk",
                layerId: "plankart1",
                layerInfo: true,
                customLayerInfo:
                  "<h3>Plankart 1</h3>Plankartet viser hva som kan bygges hvor (de ulike formålene). Planen viser også enkelte av områdene hvor det må tas spesielle hensyn. De øvrige hensynssonene vises på Plankart 2. ",
                groupCheckbox: true,
                layers: [
                  {
                    olType: "group",
                    //layerInfo: true,
                    title: "Arealformål",
                    layerId: "kp_pk1_arealformaal",
                    //url: parameters.kpaplankart,
                    //layerName: "KpArealformålOmrade",
                    //customLayerInfo: helptext.getInfoTextFor("kp_pk1_arealformaal"),
                    visible: true,
                    default: true,
                    groupCheckbox: true,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: true,
                        title: "Bebyggelse og anlegg",
                        layerId: "Bebyggelse",
                        url: parameters.kpaplankart,
                        layerName: "Bebyggelse og anlegg",
                        visible: true,
                        customLayerInfo:
                          '<h4>Tegnforklaring</h4><img src="' +
                          parameters.kpaplankart +
                          '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Bebyggelse og anlegg&format=image/png"><br/><br/>',
                      },
                      {
                        olType: "image",
                        layerInfo: true,
                        title: "Samferdselsanlegg og teknisk infrastruktur",
                        layerId: "Samferdselsanlegg",
                        url: parameters.kpaplankart,
                        layerName: "Samferdselsanlegg og teknisk infrastruktur",
                        visible: true,
                        customLayerInfo:
                          '<h4>Tegnforklaring</h4><img src="' +
                          parameters.kpaplankart +
                          '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Samferdselsanlegg og teknisk infrastruktur&format=image/png"><br/><br/>',
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Grønnstruktur",
                        layerId: "Grønnstruktur",
                        url: parameters.kpaplankart,
                        layerName: "Grønnstruktur",
                        visible: true,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Forsvaret",
                        layerId: "Forsvaret",
                        url: parameters.kpaplankart,
                        layerName: "Forsvaret",
                        visible: true,
                      },
                      {
                        olType: "image",
                        layerInfo: true,
                        title: "Landbruks,- natur- og friluftsformål",
                        layerId: "Landbruks",
                        url: parameters.kpaplankart,
                        layerName: "Landbruks- natur- og friluftsformål",
                        visible: true,
                        customLayerInfo:
                          '<h4>Tegnforklaring</h4><img src="' +
                          parameters.kpaplankart +
                          '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Landbruks- natur- og friluftsformål&format=image/png"><br/><br/>',
                      },
                      {
                        olType: "image",
                        layerInfo: true,
                        title:
                          "Bruk og vern av sjø og vassdrag med tilhørende strandsone",
                        layerId: "vassdrag",
                        url: parameters.kpaplankart,
                        layerName:
                          "Bruk og vern av sjø og vassdrag med tilhørende strandsone",
                        visible: true,
                        customLayerInfo:
                          '<h4>Tegnforklaring</h4><img src="' +
                          parameters.kpaplankart +
                          '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Bruk og vern av sjø og vassdrag med tilhørende strandsone&format=image/png"><br/><br/>',
                      },
                    ],
                  },
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Hensynssoner",
                    layerId: "kp_pk1_hensynssoner",
                    groupCheckbox: true,
                    //url: parameters.kpaplankart,
                    //layerName: "Hensyn landskap,Hensyn kulturmiljø,Krav om felles planlegging",
                    //customLayerInfo: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<h4>Tegnforklaring</h4><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Hensyn landskap&format=image/png\"><br/><br/><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Hensyn kulturmiljø&format=image/png\"><br/><br/><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Krav om felles planlegging&format=image/png\"><br/><br/>" ,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hensyn landskap H550",
                        layerId: "landskap",
                        url: parameters.kpaplankart,
                        layerName: "Hensyn landskap",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Bevaring kulturmiljø H570",
                        layerId: "bevaring",
                        url: parameters.kpaplankart,
                        layerName: "Hensyn kulturmiljø",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Bevaring etter lov om kulturminner H730",
                        layerId: "bevaringh730",
                        url: parameters.kpaplankart,
                        layerName: "Bevaring etter lov om kulturminner H730",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Krav om felles planlegging H810",
                        layerId: "felles",
                        url: parameters.kpaplankart,
                        layerName: "Krav om felles planlegging",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Bestemmelseområde",
                    layerId: "kp_pk1_bestemmelseområde",
                    url: parameters.kpaplankart,
                    layerName: "Bestemmelseområde",
                    //customLayerInfo: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<h4>Tegnforklaring</h4><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Bestemmelseområde&format=image/png\">" ,
                    visible: false,
                  },
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Juridiske linjer og symboler",
                    groupCheckbox: true,
                    layerId: "kp_pk1_juridisk",
                    //url: parameters.kpaplankart,
                    //layerName: "Byggegrense,KpSamferdselLinje,Planens avgrensning,Markagrense,Kollektivknutepunkt",
                    //customLayerInfo: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<h4>Tegnforklaring</h4><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Byggegrense&format=image/png\"><br/><br/><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=KpSamferdselLinje&format=image/png\"><br/><br/><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Planens avgrensning&format=image/png\"><br/><br/><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Kollektivknutepunkt&format=image/png\"><br/><br/><img src=\"" + parameters.kpaplankart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Markagrense&format=image/png\">" ,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Planens avgrensning",
                        layerId: "avgrensning",
                        url: parameters.kpaplankart,
                        layerName: "Planens avgrensning",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Markagrense",
                        layerId: "Markagrense",
                        url: parameters.kpaplankart,
                        layerName: "Markagrense",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Fjernveg",
                        layerId: "Fjernveg",
                        url: parameters.kpaplankart,
                        layerName: "Fjernveg",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Jernbane",
                        layerId: "Jernbane",
                        url: parameters.kpaplankart,
                        layerName: "Jernbane",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Sporveg",
                        layerId: "Sporveg",
                        url: parameters.kpaplankart,
                        layerName: "Sporveg",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Farled",
                        layerId: "Farled",
                        url: parameters.kpaplankart,
                        layerName: "Farled",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Byggegrense",
                        layerId: "Byggegrense",
                        url: parameters.kpaplankart,
                        layerName: "Byggegrense",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "group",
                    layerInfo: true,
                    title: "Ikke juridiske objekter",
                    layerId: "kp_pk1_ikke_juridisk",
                    customLayerInfo:
                      "<h4>Tegnforklaring</h4>" +
                      '<img src="' +
                      parameters.kpaplankart +
                      '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Fjordtrikk&format=image/png"><br />' +
                      '<img src="' +
                      parameters.kpaplankart +
                      '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Mulig bane&format=image/png">',
                    visible: false,
                    groupCheckbox: true,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Mulig bane,Fjordtrikk",
                        layerId: "muligbanefjordtrikk",
                        url: parameters.kpaplankart,
                        layerName: "Mulig bane,Fjordtrikk",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Indre by",
                        layerId: "kp1Indreby",
                        url: parameters.kpaplankart,
                        layerName: "Indreby",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "T-banestasjoner",
                        layerId: "tbanestasjoner",
                        url: parameters.kpaplankart,
                        layerName: "T-banestasjoner",
                        visible: false,
                      },
                    ],
                  },
                ],
              },
              {
                olType: "group",
                title: "Plankart 2 Hensynssoner",
                layerId: "kp_pk2_hensynssoner",
                layerInfo: true,
                customLayerInfo:
                  "<h3>Plankart 2</h3>Dette plankartet viser flere områder hvor det må tas spesielle hensyn ved gjennomføring av tiltak.",
                groupCheckbox: true,
                visible: false,
                layers: [
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Sikringssoner",
                    layerId: "KpSikringSone",
                    groupCheckbox: true,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Nedslagsfelt drikkevann H110 ",
                        layerId: "drikkevann",
                        url: parameters.kpaplankart,
                        layerName: "Nedslagsfelt drikkevann",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title:
                          "Andre sikringssoner H190_1 (eksisterende trasé for t-bane/ jernbane)",
                        layerId: "H190_1",
                        url: parameters.kpaplankart,
                        layerName: "H190_1",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title:
                          "Andre sikringssoner H190_2(framtidig trasé for t-bane/jernbane)",
                        layerId: "H190_2",
                        url: parameters.kpaplankart,
                        layerName: "H190_2",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title:
                          "Andre sikringssoner H190_3 (trasé for veitunnel)",
                        layerId: "H190_3",
                        url: parameters.kpaplankart,
                        layerName: "H190_3",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title:
                          "Andre sikringssoner H190_4 (trasé for veioverbygg/lokk)",
                        layerId: "H190_4",
                        url: parameters.kpaplankart,
                        layerName: "H190_4",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title:
                          "Andre sikringssoner H190_5 (trasé for vann- og avløpsanlegg) ",
                        layerId: "H190_5",
                        url: parameters.kpaplankart,
                        layerName: "H190_5",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Andre sikringssoner H190_6 (oljesisterne)",
                        layerId: "H190_6",
                        url: parameters.kpaplankart,
                        layerName: "H190_6",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Andre sikringssoner H190_7 (pumpestasjon)",
                        layerId: "H190_7",
                        url: parameters.kpaplankart,
                        layerName: "H190_7",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title:
                          "Andre sikringssoner H190_8 (transformatorstasjon)",
                        layerId: "H190_8",
                        url: parameters.kpaplankart,
                        layerName: "H190_8",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Andre sikringssoner H190_9 (berghall)",
                        layerId: "H190_9",
                        url: parameters.kpaplankart,
                        layerName: "H190_9",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Andre sikringssoner H190_10 (gassledning)",
                        layerId: "H190_10",
                        url: parameters.kpaplankart,
                        layerName: "H190_10",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Andre sikringssoner H190_11 (omformer)",
                        layerId: "H190_11",
                        url: parameters.kpaplankart,
                        layerName: "H190_11",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Faresoner",
                    layerId: "faresone",
                    groupCheckbox: true,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Flomfare H320",
                        layerId: "Flomfare",
                        url: parameters.kpaplankart,
                        layerName: "Flomfare",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Brann- og eksplosjonsfare H350",
                        layerId: "brann",
                        url: parameters.kpaplankart,
                        layerName: "Brann- og eksplosjonsfare",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Sone for militær virksomhet H380",
                        layerId: "militar",
                        url: parameters.kpaplankart,
                        layerName: "Sone for militær virksomhet",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Annen fare (deponi) H390",
                        layerId: "annenfare",
                        url: parameters.kpaplankart,
                        layerName: "Annen fare",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "group",
                    layerInfo: true,
                    title: "Infrastruktursone",
                    layerId: "Infrastruktursone",
                    groupCheckbox: true,
                    customLayerInfo:
                      '<h4>Tegnforklaring</h4><img src="' +
                      parameters.kpaplankart +
                      '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Infrastruktursone&format=image/png">',
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Vei til gate Rv4 H410_1",
                        layerId: "VeitilgateRv4H410_1",
                        url: parameters.kpaplankart,
                        layerName: "Vei til gate Rv4 H410_1",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title:
                          "Vei til gate Østre Aker vei og Økernveien H410_2",
                        layerId: "VeitilgateØstreAkerveiogØkernveienH410_2",
                        url: parameters.kpaplankart,
                        layerName:
                          "Vei til gate Østre Aker vei og Økernveien H410_2",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Kollektivakser i Hovinbyen H410_3",
                        layerId: "KollektivakseriHovinbyenH410_3",
                        url: parameters.kpaplankart,
                        layerName: "Kollektivakser i Hovinbyen H410_3",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Bussoppstillingsplass Etterstadsletta H410_4",
                        layerId: "BussoppstillingsplassEtterstadslettaH410_4",
                        url: parameters.kpaplankart,
                        layerName:
                          "Bussoppstillingsplass Etterstadsletta H410_4",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "T-banebase Risløkka H410_5",
                        layerId: "T-banebaseRisløkkaH410_5",
                        url: parameters.kpaplankart,
                        layerName: "T-banebase Risløkka H410_5",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Trikketrasé Sinsen-Bjerke H410_6",
                        layerId: "TrikketraséSinsen-BjerkeH410_6",
                        url: parameters.kpaplankart,
                        layerName: "Trikketrasé Sinsen-Bjerke H410_6",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Opparbeiding av trygg flomvei H410_7",
                        layerId: "OpparbeidingavtryggflomveiH410_7",
                        url: parameters.kpaplankart,
                        layerName: "Opparbeiding av trygg flomvei H410_7",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Sone med angitte særlige hensyn",
                    layerId: "KpAngittHensynSone",
                    url: parameters.kpaplankart,
                    groupCheckbox: true,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hensyn bevaring naturmiljø H560 - alternativ 1",
                        layerId: "HensynbevaringnaturmiljøH560alternativ1",
                        url: parameters.kpaplankart,
                        layerName: "Hensyn naturmiljø - alt 1",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hensyn bevaring naturmiljø H560 - alternativ 2",
                        layerId: "hensynnatur",
                        url: parameters.kpaplankart,
                        layerName: "Hensyn naturmiljø - alt 2",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hensyn landbruk H510",
                        layerId: "hensynlandbruk",
                        url: parameters.kpaplankart,
                        layerName: "Hensyn landbruk",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Båndlegging etter andre lover (energiloven) H740",
                    layerId: "Båndlegging",
                    url: parameters.kpaplankart,
                    layerName: "Båndlegging etter andre lover",
                    customLayerInfo:
                      '<h4>Tegnforklaring</h4><img src="' +
                      parameters.kpaplankart +
                      '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Båndlegging etter andre lover&format=image/png">',
                    visible: false,
                  },
                ],
              },
              {
                olType: "group",
                layerInfo: true,
                title: "T1 Utvikling og fortetting",
                groupCheckbox: true,
                layerId: "t1",
                customLayerInfo:
                  "<h3>T1 Utvikling og fortetting</h3>Byggesonen er inndelt i ulike områdekategorier med ulike føringer for arealbruk. T1 viser inndelingen av fremtidig bebyggelse og anlegg (utviklingsområder), nåværende bebyggelse og anlegg, prioriterte stasjonsnære områdene og områder der høyhus kan vurderes. T1 utvikling og fortetting brukes særlig sammen med bestemmelsenes pkt. 12. Se også kapittel 6 i planbeskrivelsen.",
                //<h4>Tegnforklaring</h4><img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=T1&format=image/png\">" ,
                visible: false,
                layers: [
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Utviklingsområde U1",
                    layerId: "t1u1",
                    url: parameters.kpatemakart,
                    layerName: "U1",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Utviklingsområde U2",
                    layerId: "t1u2",
                    url: parameters.kpatemakart,
                    layerName: "U2",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Utviklingsområde U3",
                    layerId: "t1u3",
                    url: parameters.kpatemakart,
                    layerName: "U3",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Utviklingsområde U4",
                    layerId: "t1u4",
                    url: parameters.kpatemakart,
                    layerName: "U4",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Utviklingsområde U5",
                    layerId: "t1u5",
                    url: parameters.kpatemakart,
                    layerName: "U5",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Utviklingsområde U6",
                    layerId: "t1u6",
                    url: parameters.kpatemakart,
                    layerName: "U6",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Indre by (IB)",
                    layerId: "t1k1",
                    url: parameters.kpatemakart,
                    layerName: "IB",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Ytre by (YB)",
                    layerId: "t1k2",
                    url: parameters.kpatemakart,
                    layerName: "YB",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Campusområder (C)",
                    layerId: "t1k3",
                    url: parameters.kpatemakart,
                    layerName: "C",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Grønn grense",
                    layerId: "Gronnt1",
                    url: parameters.kpatemakart,
                    layerName: "Grønn grense",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Prioriterte stasjonsnære områder",
                    layerId: "Prit1",
                    url: parameters.kpatemakart,
                    layerName: "Prioriterte stasjonsnære områder",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Områder hvor høyhus kan vurderes",
                    layerId: "hoyt1",
                    url: parameters.kpatemakart,
                    layerName:
                      "Områder hvor høyhus kan vurderes,Sentrumsringen",
                    visible: false,
                  },
                ],
              },
              {
                olType: "group",
                layerInfo: true,
                title: "T2 Områder med plankrav",
                layerId: "t2",
                groupCheckbox: true,
                customLayerInfo:
                  "<h3>T2 Områder med plankrav</h3>T2 gir en oversikt over hvor plankravet gjelder. Kartet brukes sammen med bestemmelsenes pkt. 3. Se også kapittel 5 i planbeskrivelsen.",
                visible: false,
                layers: [
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "U2, U3 U4, U5 og U6 (pkt. 3.2)",
                    layerId: "U2U3U4U5ogU6",
                    url: parameters.kpatemakart,
                    layerName: "U2_U3_U4_U5_U6 (pkt. 3.2)",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "U4 og U6 (unntak kan gis jf. pkt. 3.2.1 d)",
                    layerId: "U4U6",
                    url: parameters.kpatemakart,
                    layerName: "U4 og U6 (unntak kan gis jf. pkt. 3.2.1 d)",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Utdaterte reguleringsplaner (pkt. 3.3 a)",
                    layerId: "Utdatertereguleringsplaner",
                    url: parameters.kpatemakart,
                    layerName: "Utdaterte reguleringsplaner",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title:
                      "S-2864, S-3272, S-3273, og S-3469 (unntak kan gis jf. pkt. 3.3 b)",
                    layerId: "S-2864S-3272S-3273ogS-3469",
                    url: parameters.kpatemakart,
                    layerName:
                      "S-2864_S-3272_S-3273_S-3469 (unntak kan gis jf. pkt. 3.3 b)",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title:
                      "Soneplanen og tilhørende planer helt eller delvis opphevet i kommuneplanens arealdel 2015 (vurderes mot pkt 3.1)",
                    layerId:
                      "Soneplanenogtilhørendeplanerheltellerdelvisopphevetikommuneplanensarealdel2015",
                    url: parameters.kpatemakart,
                    layerName:
                      "Soneplanen og tilhørende planer helt eller delvis opphevet i kommuneplanens arealdel 2015 (vurderes mot pkt 3.1)",
                    visible: false,
                  },
                ],
              },
              {
                olType: "group",
                layerInfo: true,
                title: "T3 Nabolag",
                layerId: "t3",
                groupCheckbox: true,
                customLayerInfo:
                  "<h3>T3 Nabolag</h3>Temakartet samler tema tilknyttet stedsutvikling. Kartet viser turveier, områder med behov for trygg tilgang til leke- og rekreasjonsareal, områdesentrum og nabolagssentrum. T3 Nabolag brukes sammen med bestemmelsenes pkt. 6.1, 7.2 og 7.3. Se også kapittel 7 og 10 i planbeskrivelsen.",
                visible: false,
                layers: [
                  {
                    olType: "image",
                    layerInfo: false,
                    title:
                      "Områder med behov for trygg tilgang til leke- og rekreasjonsareal",
                    layerId: "tryggTilgang",
                    url: parameters.kpatemakart,
                    layerName: "tryggTilgang",
                    visible: false,
                  },
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Turvei",
                    layerId: "Turvei",
                    groupCheckbox: true,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hovedturvei – eksisterende / planmessig sikret",
                        layerId: "Hovedturvei_eksisterende",
                        url: parameters.kpatemakart,
                        layerName: "Hovedturvei – eksisterende",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hovedturvei – framtidig",
                        layerId: "Hovedturvei_framtidig",
                        url: parameters.kpatemakart,
                        layerName: "Hovedturvei – framtidig",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Annen viktig forbindelse",
                        layerId: "gangforbindelse",
                        url: parameters.kpatemakart,
                        layerName: "Annen viktig forbindelse",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Framtidig turdrag - prinsipptrasé",
                        layerId: "framtidTur",
                        url: parameters.kpatemakart,
                        layerName: "framtidTur",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Krysningspunkt som krever tiltak",
                        layerId: "Krysningspunkt",
                        url: parameters.kpatemakart,
                        layerName: "Krysningspunkt",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Den grønne ringen",
                        layerId: "GronnRing",
                        url: parameters.kpatemakart,
                        layerName: "Den grønne ringen",
                        visible: false,
                      },
                    ],
                  },

                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Områdesentrum",
                    layerId: "Områdesentrum",
                    url: parameters.kpatemakart,
                    layerName: "Områdesentrum",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Nabolagssentrum",
                    layerId: "Nabolagssentrum",
                    url: parameters.kpatemakart,
                    layerName: "Nabolagssentrum",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Indre by",
                    layerId: "IndrebyT3",
                    url: parameters.kpatemakart,
                    layerName: "Indreby",
                    visible: false,
                  },
                ],
              },
              {
                olType: "group",
                layerInfo: true,
                title: "T4 Naturmiljø og vassdrag",
                layerId: "t4",
                groupCheckbox: true,
                customLayerInfo:
                  "<h3>T4 Naturmiljø og vassdrag</h3>Temakartet viser kartlagte naturmiljø, åpne og lukkede vassdrag, og vassdrag med potensial for gjenåpning. T4 Naturmiljø og vassdrag brukes sammen med bestemmelsenes pkt. 10.1 og 10.2 Se også kapittel 10 i planbeskrivelsen.",
                /*<h4>Tegnforklaring</h4>"+
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Myr&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Naturtype A&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Naturtype B&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Naturtype C&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Hovedvassdrag&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Sidevassdrag&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Øvrige vassdrag&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Vassdrag i marka&format=image/png\"><br/>" +
						"Ikke juridiske objekter<br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Hovedvassdrag i rør&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Sidevassdrag i rør&format=image/png\"><br/>" +
						"<img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Vassdrag med potensiale for gjenåpning&format=image/png\"><br/>", */
                //dependent: "t4b",
                visible: false,
                layers: [
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Naturmiljø",
                    layerId: "Naturmiljø",
                    groupCheckbox: true,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Naturtype C-områder",
                        layerId: "naturC",
                        url: parameters.kpatemakart,
                        layerName: "Naturtype C",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Naturtype B-områder",
                        layerId: "naturB",
                        url: parameters.kpatemakart,
                        layerName: "Naturtype B",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Naturtype A-områder",
                        layerId: "naturA",
                        url: parameters.kpatemakart,
                        layerName: "Naturtype A",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Vassdrag",
                    layerId: "Vassdrag",
                    groupCheckbox: true,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hovedvassdrag",
                        layerId: "Hovedvassdrag",
                        url: parameters.kpatemakart,
                        layerName: "Hovedvassdrag,Hovedvassdrag_linjer",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Sidevassdrag",
                        layerId: "Sidevassdrag",
                        url: parameters.kpatemakart,
                        layerName: "Sidevassdrag,Sidevassdrag_linjer",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Øvrige bekker og dammer",
                        layerId: "Øvrige",
                        url: parameters.kpatemakart,
                        layerName: "Øvrige vassdrag,Øvrige vassdrag_linjer",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Lukkede vassdrag",
                    layerId: "Lukkede",
                    groupCheckbox: true,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hovedvassdrag i rør",
                        layerId: "Hovedvassdrag_rør",
                        url: parameters.kpatemakart,
                        layerName: "Hovedvassdrag i rør",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Sidevassdrag i rør",
                        layerId: "Sidevassdrag_rør",
                        url: parameters.kpatemakart,
                        layerName: "Sidevassdrag i rør",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Vassdrag med potensiale for gjenåpning",
                        layerId: "gjenåpning",
                        url: parameters.kpatemakart,
                        layerName: "Vassdrag med potensiale for gjenåpning",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Markagrense",
                    layerId: "Markagrenset4",
                    url: parameters.kpaplankart,
                    layerName: "Markagrense",
                    visible: false,
                  },
                ],
              },
              /*,{
						olType: "image",
						layerInfo: false,
						layerId: "t4b",
						displayInLayerMenu: false,
						url: parameters.kpaplankart,
						layerName: "Planens avgrensning,Markagrense",
						visible: false,
					}*/ {
                olType: "group",
                layerInfo: true,
                title: "T5 Kulturmiljøinteresser",
                layerId: "t5",
                groupCheckbox: true,
                customLayerInfo:
                  "<h3>T5 kulturmiljøinteresser</h3>T5 viser kulturmiljøer med utfyllende informasjon om områdene som inngår i hensynssone H570 bevaring kulturmiljø i plankart 1, samt NB!-områder og bestemmelsesområder for etter-reformatorisk arkeologi. T5 Kulturmiljøinteresser brukes sammen med bestemmelsenes pkt. 18.4 i kombinasjon med plankart 1. Se også kapittel 7 i planbeskrivelsen.",
                /*<h4>Tegnforklaring</h4><img src=\"" + parameters.kpatemakart + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=T5&format=image/png\">" ,*/
                visible: false,
                layers: [
                  {
                    olType: "group",
                    layerInfo: false,
                    title: "Kulturmiljøer",
                    layerId: "Kulturmiljøer",
                    groupCheckbox: true,
                    visible: false,
                    layers: [
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Sentrumsmiljøer i hovedstaden",
                        layerId: "Sentrumsmiljøer",
                        url: parameters.kpatemakart,
                        layerName: "Sentrumsmiljøer",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "1800-tallets tette murby",
                        layerId: "Murby_tett",
                        url: parameters.kpatemakart,
                        layerName: "Murby tett",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "1800-tallets åpne murby",
                        layerId: "Murby_åpen",
                        url: parameters.kpatemakart,
                        layerName: "Murby åpen",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Førmoderne bystrukturer",
                        layerId: "Bystrukturer",
                        url: parameters.kpatemakart,
                        layerName: "Bystrukturer",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Trehusforsteder",
                        layerId: "Trehusforsteder",
                        url: parameters.kpatemakart,
                        layerName: "Trehusforsteder",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "De store boligprogrammene - tidlig 1900-tall",
                        layerId: "boligprogrammene",
                        url: parameters.kpatemakart,
                        layerName: "boligprogrammene",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Hagebyer",
                        layerId: "Hagebyer",
                        url: parameters.kpatemakart,
                        layerName: "Hagebyer",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Industriområder",
                        layerId: "Industri",
                        url: parameters.kpatemakart,
                        layerName: "Industri",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Institusjonsområder",
                        layerId: "Institusjon",
                        url: parameters.kpatemakart,
                        layerName: "Institusjon",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Etterkrigstidens massebyggeri",
                        layerId: "massebyggeri",
                        url: parameters.kpatemakart,
                        layerName: "massebyggeri",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Villaforsteder",
                        layerId: "Villaforsteder",
                        url: parameters.kpatemakart,
                        layerName: "Villaforsteder",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title: "Bydelssentra",
                        layerId: "Bydelssentra",
                        url: parameters.kpatemakart,
                        layerName: "Bydelssentra",
                        visible: false,
                      },
                      {
                        olType: "image",
                        layerInfo: false,
                        title:
                          "Grønne kulturmiljøer (arkeologi, jordbruk, park, friluftsliv)",
                        layerId: "Grønnekulturmiljøer",
                        url: parameters.kpatemakart,
                        layerName: "Grønne kulturmiljøer",
                        visible: false,
                      },
                    ],
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title:
                      "Områder med nasjonale kulturminneinteresser (NB!-områder) (KPA2015)",
                    layerId: "nbområder",
                    url: parameters.kpatemakart,
                    layerName:
                      "Områder med nasjonale kulturminneinteresser (NB!-områder) (KPA2015)",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title:
                      "Bestemmelsesområde potensial for etter-reformatoriske arkeologiske funn",
                    layerId: "arkeologiske",
                    url: parameters.kpatemakart,
                    layerName:
                      "Bestemmelsesområde potensial for etter-reformatoriske arkeologiske funn",
                    visible: false,
                  },
                ],
              },
              {
                olType: "group",
                layerInfo: true,
                title: "T6 Støy",
                layerId: "t6",
                customLayerInfo:
                  "<h3>T6 Støy</h3>Temakart T6 Støy viser beregnet støy fra blant annet vei, bane og havn som gule og røde støysoner, og områder med høy samlet støy- og luftforurensing. Temakartet viser også fortettingsområder (indre by og utviklingsområder U1-U5 og stille områder. T6 Støy brukes sammen med bestemmelsenes pkt. 6.5. Se også kapittel 6 i planbeskrivelsen.",
                groupCheckbox: true,
                visible: false,
                layers: [
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Gul støysone",
                    layerId: "T6_gulstoy",
                    url: parameters.kpatemakart,
                    layerName: "T6_gulstoy",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Rød støysone",
                    layerId: "T6_rodstoy",
                    url: parameters.kpatemakart,
                    layerName: "T6_rodstoy",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Høy samlet støy- og luftforurensning",
                    layerId: "samlet",
                    url: parameters.kpatemakart,
                    layerName: "Høy samlet støy- og luftforurensning",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Stille områder",
                    layerId: "stille",
                    url: parameters.kpatemakart,
                    layerName: "Stille områder",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Utviklingsområder",
                    layerId: "Utviklingsområder_støy",
                    url: parameters.kpatemakart,
                    layerName: "Utviklingsområder_støy",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: false,
                    title: "Indre by",
                    layerId: "Indre_by",
                    url: parameters.kpatemakart,
                    layerName: "Indre_by",
                    visible: false,
                  },
                ],
              },
            ],
          },
          {
            olType: "group",
            title: "Kommuneplanens arealdel 2015",
            layerId: "kp",
            layerInfo: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "group",
                title: "Plankart 1-2 Arealbruk",
                layerId: "kp_pk1_2",
                layerInfo: true,
                groupCheckbox: true,
                visible: false,
                layers: [
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Arealformål",
                    layerId: "kp_pk1-2_arealformaal",
                    url: parameters.kommuneplanurl,
                    layerName: "arealformaal",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Hensynssoner",
                    layerId: "kp_pk1-2_hensynssoner",
                    url: parameters.kommuneplanurl,
                    layerName: "hoved_hensyn",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Juridiske linjer og symboler",
                    layerId: "kp_pk1-2_juridisk",
                    url: parameters.kommuneplanurl,
                    layerName: "hoved_juridisk",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Ikke juridiske objekter",
                    layerId: "kp_pk1-2_ikke_juridisk",
                    url: parameters.kommuneplanurl,
                    layerName: "hoved_ikke_juridisk",
                    visible: false,
                  },
                ],
              },
              {
                olType: "image",
                layerInfo: true,
                title: "Plankart 2-2 Hensynssoner",
                layerId: "kp_pk2_2",
                url: parameters.kommuneplanurl,
                layerName: "hensyn_hensyn",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T1 Støy",
                layerId: "kp_tema_juridisk_stoy",
                url: parameters.kommuneplanurl,
                layerName: "tema_t1",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T2 Luftforurensing (nitrogendioksid)",
                layerId: "kp_tema_ikke_juridisk_luftforurensing_t2",
                url: parameters.kommuneplanurl,
                layerName: "t2_luftforurensing,markagrense,planens_avgrensning",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T3 Luftforurensing (svevestøv)",
                layerId: "kp_tema_ikke_juridisk_luftforurensing_t3",
                url: parameters.kommuneplanurl,
                layerName: "t3_luftforurensing,markagrense,planens_avgrensning",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T4 Naturmiljø",
                layerId: "kp_tema_juridisk_naturmiljo",
                url: parameters.kommuneplanurl,
                layerName: "tema_t4,markagrense,planens_avgrensning",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T5 Kulturminnevern",
                layerId: "kp_tema_ikke_juridisk_kulturminnevern",
                url: parameters.kommuneplanurl,
                layerName:
                  "t5_baandlegging_andre_lover,t5_avklart_uavklart_indre_by,t5_avklart_uavklart_ytre_by,t5_Verneklasse2_Tema,t5_baandlegging_lov_om_kulturminner,t5_hensynssone_c,t5_nasjonal_verneverdi,t5_indre_by,t5_freda_bygninger",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T6 Storulykke",
                layerId: "kp_tema_juridisk_storulykke",
                url: parameters.kommuneplanurl,
                layerName:
                  "t6_brann_eksplosjonsfare,markagrense,planens_avgrensning,t4_marka_temakart",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T7 Blågrønn struktur",
                layerId: "kp_tema_juridisk_blaagronn_struktur",
                url: parameters.kommuneplanurl,
                layerName: "tema_t7,markagrense,planens_avgrensning",
                dontCascade: true,
                visible: false,
              },
            ],
          },
        ],
      },
      {
        olType: "group",
        layerId: "temakart",
        title: "Temakart",
        collapsible: true,
        groupCheckbox: false,
        altTarget: "fkb",
        layers: [
          {
            olType: "group",
            layerId: "grunnforhold",
            title: "Grunnforhold  - kvikkleire",
            collapsible: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "image",
                title: "Påviste kvikkleiresoner fra NVE",
                layerId: "KvikkleireFaregrad_NVE",
                url: "https://nve.geodataonline.no/arcgis/services/SkredKvikkleire2/MapServer/WmsServer",
                layerName: "KvikkleireFaregrad",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                attribution: "©NVE",
                attributionId: "c-nve",
                customLayerInfo:
                  '<h3>Kvikkleiresoner fra </h3>Data fra Norges vassdrags- og energidirektorat (NVE).</p><p>Kvikkleiresone er et område hvor det er risiko for kvikkleireskred. En kvikkleiresone består av to soner: et løsneområde og et utløpsområde. Løsneområdet er der skredet starter, og utløpsområdet er området som blir eller kan bli rammet av skredet.</p><p>Se også <a target = _blank href="https://register.geonorge.no/data/documents/Produktark_Kvikkleire_v4_kvikkleire11012019_.pdf">«Produktark: Kvikkleire» fra NVE / Norge digitalt <i class=\'icon-new-window\'></i></a></p><img src="https://nve.geodataonline.no/arcgis/services/SkredKvikkleire2/MapServer/WmsServer?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=KvikkleireFaregrad&format=image/png">',
              },
              {
                olType: "tile",
                title: "Marin grense",
                layerId: "maringrense",
                url: parameters.risikourl,
                layerName: "Maringrense",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  "<h3>Maringrense</h3>Du kan ikke bygge noe som kan utløse eller rammes av kvikkleireskred. <i>Under den marine grensen kan det finnes kvikkleire.</i> Kvikkleire er marin leire der saltet som binder leiren sammen, over tid har blitt vasket bort. Dermed blir strukturen ustabil, og økte belastninger, som for eksempel gravearbeider, fyllinger eller kraftige vibrasjoner, kan utløse skred. <a href='//od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_kvikkleireskred.html' target='_blank'>Du finner mer informasjon om kvikkleire i vårt faktaark <i class='icon-new-window vd-glyphlink glyphicons new_window_alt'></i></a>.</p><p>Dersom du skal bygge innenfor dette området, må du sørge for at det vurderes om det er nødvendig med geotekniske undersøkelser av grunnen. For reguleringsplaner må det foretas geotekniske prøveboringer, for å fastslå om det finnes kvikkleire eller ikke. Det kan være nødvendig med spesiell ansvarsbelegging i en byggesak. Det er gjort et stort antall grunnboringer i Oslo, og i noen tilfeller vil det være mulig å gjenbruke eksisterende data. Ta kontakt med kommunen på e-post <a href='mailto:dig.kart@pbe.oslo.kommune.no'>dig.kart@pbe.oslo.kommune.no</a> eller telefon 23 49 10 00 for å finne ut hvilken informasjon som finnes om din tomt.</p><p><strong>Her kan du lese mer om marin grense og kvikkleire</strong></p><ul><li><a href='https://publikasjoner.nve.no/veileder/2019/veileder2019_01.pdf' target='_blank'>NVE veileder 1/2019 - Sikkerhet mot kvikkleireskred <i class='icon-new-window'></i></a></li><li><a href='https://lovdata.no/dokument/NL/lov/2008-06-27-71/KAPITTEL_4-9#§28-1' target='_blank'>plan- og bygningsloven § 28-1<i class='icon-new-window'></i></a></li><li><a href='https://dibk.no/byggereglene/byggteknisk-forskrift-tek17/7/7-3/' target='_blank'>byggteknisk forskrift (TEK17) § 7-3 Sikkerhet mot skred<i class='icon-new-window'></i></a> (se veiledning til 2. ledd, bokstav B. Kvikkleireskred)</li></ul>",
              },
              {
                olType: "image",
                title: "Borepunkter med påvist leire",
                layerId: "Leire",
                url: parameters.grunnforholdURL,
                layerName: "Leire",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Borepunkter hvor leire er påvist</h3><p>Kart som viser borepunkter hvor leire er påvist, viser digitalisert informasjon fra Oslo kommunes undergrunnsarkiv – et arkiv som inneholder geotekniske boringer gjennomført i Oslo de siste 100 årene.</p><p><b>Usikkerheter i kartet</b></p><p>Per i dag har vi ikke digitalisert all informasjon om Oslo i kommunens undergrunnsarkiv. Derfor finner du heller ikke digitalisert informasjon fra hele Oslo i karttjenesten.</p><p>Funn av leire i et borepunkt er ikke det samme som at det ikke er funnet kvikkleire i et borepunkt. Det kan rett og slett være at det ikke er gjennomført boringer og tester som viser om det er kvikkleire eller ikke i et område.</p><p>Du kan få detaljert informasjon om boringen og dens resultater ved å lese hele rapporten. Rapporter fra grunnundersøkelser i undergrunnsarkivet kan bestilles fra <a href="mailto:dig.kart@pbe.oslo.kommune.no">dig.kart@pbe.oslo.kommune.no</a></p><p>Kartet er oppdatert 4.8.2022</p><img src="' +
                  parameters.grunnforholdURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Leire&format=image/png">',
              },
              {
                olType: "image",
                title: "Borepunkter med påvist kvikkleire",
                layerId: "Kvikkleire",
                url: parameters.grunnforholdURL,
                layerName: "Kvikkleire",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Borepunkter hvor kvikkleire er påvist</h3><p>Kart som viser borepunkter hvor kvikkleire er påvist, viser digitalisert informasjon fra Oslo kommunes undergrunnsarkiv – et arkiv som inneholder geotekniske boringer gjennomført i Oslo de siste 100 årene. Funn av kvikkleire i et borepunkt er ikke det samme som risiko for kvikkleireskred i et område.</p><p>Du kan lese mer om kvikkleire på NVEs hjemmesider: <a target=_blank href="https://www.nve.no/om-nve/spor-nve/om-kvikkleire/">https://www.nve.no/om-nve/spor-nve/om-kvikkleire <i class=\'icon-new-window\'></i></a></p><p>Har du, eller skal du utføre geotekniske boringer i Oslo? For å sikre gjenbruk så anbefaler vi at dataene deles i Norges Nasjonale database for grunnundersøkelser, NADAG.</p><p><b>Usikkerheter i kartet</b></p><p>Per i dag har vi ikke digitalisert all informasjon i Oslo kommunes undergrunnsarkiv. Derfor finner du heller ikke digitalisert informasjon fra hele Oslo i karttjenesten.</p><p>Definisjonene av kvikkleire har endret seg over tid. Det betyr at det som har vært definert som kvikkleire historisk, ikke nødvendigvis defineres som kvikkleire i dag. Du kan få detaljert informasjon om boringen og dens resultater ved å lese hele rapporten. Rapporter fra grunnundersøkelser i undergrunnsarkivet kan bestilles fra <a href="mailto:dig.kart@pbe.oslo.kommune.no">dig.kart@pbe.oslo.kommune.no</a></p><p>Kartet er oppdatert 4.8.2022</p><img src="' +
                  parameters.grunnforholdURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Kvikkleire&format=image/png">',
              },
              {
                olType: "image",
                title: "Observasjoner av fjell i dagen",
                layerId: "Fjellidagen",
                url: parameters.grunnforholdURL,
                layerName: "Fjellidagen",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Kart som viser observasjoner av berg i dagen</h3>Kartet viser hvor det er observert berg. Datasettet er samlet inn over lang tid og de aller fleste punktene er kartlagt gjennom befaring.</p><p>Det finnes ikke informasjon om bergart i denne kartløsningen. Informasjon om bergart kan du finne i <a target=_blank href="https://geo.ngu.no/kart/berggrunn_mobil/">NGUs nasjonale berggrunnsdatabase <i class=\'icon-new-window\'></i></a><img src="' +
                  parameters.grunnforholdURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Fjellidagen&format=image/png">',
              },
              {
                olType: "image",
                title: "Dybde til antatt berg",
                layerId: "Dybde_til_fjell",
                url: parameters.grunnforholdURL,
                layerName: "Dybde_til_fjell",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Dybde til antatt berg</h3><p>Kartet viser dybde til antatt berg i meter for byggesonen i Oslo kommune.</p><p><b>Usikkerheter i kartet</b></p><p>Boringene som kartet er basert på er utført med ulike metoder og på ulike tidspunkter, det er ikke heller alle boringer som har funnet fjell. Kartet inneholder derfor usikkerheter. Dybde til bergkartet viser bare informasjon om dybder til berg som er nærmere enn 50 meter fra en boring. Vi anbefaler at kartet brukes som veiledende informasjon. Kartet er laget i 2016.</p><p><b>Hvor kommer informasjonen i kartet fra?</b></p><p>Kartet er basert på 186 260 borepunkter som er hentet fra flere ulike kilder og behandlet (interpolert) i et geografisk informasjonssystem (GIS).</p><p>Boringene er hentet fra Oslo kommunes undergrunnsarkiv, kommunens grunnvannsdatabase, NADAG (Nasjonal database for grunnundersøkelser) og GRANADA (Nasjonal grunnvannsdatabase).</p><p>Oslo kommunes undergrunnsarkiv inneholder geotekniske boringer gjennomført i Oslo de siste 100 årene.</p><p>Du kan få detaljert informasjon om boringen og dens resultater ved å lese hele rapporten. Rapporter fra grunnundersøkelser i undergrunnsarkivet kan bestilles fra <a href="mailto:dig.kart@pbe.oslo.kommune.no">dig.kart@pbe.oslo.kommune.no</a></p><p>NADAG og GRANADA driftes av NGU (Norges geologiske undersøkelse) og er tilgjengelig på <a target=_blank href="http://geo.ngu.no/kart/nadag/">http://geo.ngu.no/kart/nadag <i class=\'icon-new-window\'></i></a> og <a target=_blank href="http://geo.ngu.no/kart/granada/">http://geo.ngu.no/kart/granada <i class=\'icon-new-window\'></i></a><img src="' +
                  parameters.grunnforholdURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Dybde_til_fjell&format=image/png">',
              },
            ],
          },
          {
            olType: "group",
            title: "Skred i bratt terreng",
            layerId: "bratt",
            layerInfo: true,
            customLayerInfo:
              "<h3>Skred i bratt terreng</h3><p>Skred i bratt terreng omfatter skredtypene snøskred, sørpeskred, flomskred, jordskred, steinsprang og steinskred. Hvilke skredprosesser som kan være aktuelle avhenger av faktorer som helning, løsmassedekke, type berg, forekomst og plassering av sprekker og forvitringssoner i berg, vegetasjon og skog, samt vannsig og bekkeløp.</p><p>Her kan du lese mer om skred i bratt terreng:<ul><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023037534&fileid=10696208\">Kart for skred i bratt terreng  <i class='icon-new-window'></i></a></li><li>Kommuneplanens bestemmelser 4.3</li><li>ROS-analysen om skred i bratt terreng</li></ul>",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "tile",
                title: "Helningskart fra NVE",
                layerId: "skred1",
                url: "https://nve.geodataonline.no/arcgis/services/Bratthet/MapServer/WMSServer?",
                layerName: "Bratthet_jordskred",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  '<h3>Helningskart fra NVE</h3>Nasjonalt bratthetskart fra NVE til vurdering av skredfare i bratt terreng.<p><ul><li>Steinsprang og steinskred skal vurderes i og under skråninger brattere enn 45 grader</li><li>Snøskred skal vurderes i og under skråninger brattere enn 25 grader</li><li>Jordskred/løsmasseskred skal vurderes i og under skråninger brattere enn 20 grader</li><li>Flomskred skal vurderes i forsenkninger og bekkeløp brattere enn 15 grader</li><li>Sørpeskred skal vurderes der det er forsenkninger eller bekkeløp som kan samle opp vann i snødekket</li></ul><br/><img src="https://nve.geodataonline.no/arcgis/services/Bratthet/MapServer/WMSServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Bratthet_jordskred&format=image/png">',
                attribution: "©NVE",
                attributionId: "c-nve",
              },
              {
                olType: "tile",
                title: "Nasjonale aktsomhetskart Steinsprang",
                layerId: "skred2",
                url: "https://nve.geodataonline.no/arcgis/services/SkredSteinAktR/MapServer/WmsServer?",
                layerName: "Utlosningsomrade,Utlopsomrade",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  '<h3>Nasjonale aktsomhetskart Steinsprang</h3>Nasjonalt aktsomhetskart som viser potensielle løsne- og utløpsområder for steinsprang. Kartet er laget fra den landsdekkende høydemodellen med oppløsning på 25x25 meter. Denne glatter ut terrenget og små skrenter og terrasser i terrenget skjules. Det kan derfor være skredutsatte områder også utenfor aktsomhetssone. Mer informasjon om kartet finnes <a target=\'_blank\' href=" https://www.nve.no/naturfare/utredning-av-naturfare/om-kart-og-kartlegging-av-naturfare/om-kartlegging-av-skredfare-i-bratt-terreng/aktsomhetskart-for-steinsprang/">hos Norges vassdrags- og energidirektorat <i class=\'icon-new-window\'></i></a><br/><img src="https://nve.geodataonline.no/arcgis/services/SkredSteinAktR/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Utlosningsomrade&format=image/png"><br /><img src="https://nve.geodataonline.no/arcgis/services/SkredSteinAktR/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Utlopsomrade&format=image/png">',
                attribution: "©NVE",
                attributionId: "c-nve",
              },
              {
                olType: "tile",
                title: "Nasjonale aktsomhetskart Snøskred",
                layerId: "skred3",
                url: "https://nve.geodataonline.no/arcgis/services/SkredSnoAktR/MapServer/WmsServer?",
                layerName: "Utlosningsomrade,Utlopsomrade",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  '<h3>Nasjonale aktsomhetskart Snøskred</h3>Nasjonalt aktsomhetskartet som viser potensielle løsne- og utløpsområder for snøskred. Kartet er laget fra den landsdekkende høydemodellen med oppløsning på 25x25 meter. Denne glatter ut terrenget og små skrenter og terrasser i terrenget skjules. Det kan derfor være skredutsatte områder også utenfor aktsomhetssone. Mer informasjon om kartet finnes <a target=\'_blank\' href=" https://www.nve.no/naturfare/utredning-av-naturfare/om-kart-og-kartlegging-av-naturfare/om-kartlegging-av-skredfare-i-bratt-terreng/aktsomhetskart-for-snoskred/">hos Norges vassdrags- og energidirektorat <i class=\'icon-new-window\'></i></a><br/><img src="https://nve.geodataonline.no/arcgis/services/SkredSnoAktR/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Utlosningsomrade&format=image/png"><br /><img src="https://nve.geodataonline.no/arcgis/services/SkredSnoAktR/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Utlopsomrade&format=image/png">',
                attribution: "©NVE",
                attributionId: "c-nve",
              },
              {
                olType: "tile",
                title: "Nasjonale aktsomhetskart Jord-Flomskred",
                layerId: "skred4",
                url: "https://nve.geodataonline.no/arcgis/services/SkredJordFlomAktR1/MapServer/WmsServer?",
                layerName: "Potensielt_Jord-Flomskredfare",
                layerInfo: true,
                visible: false,
                attribution: "©NVE",
                attributionId: "c-nve",
                customLayerInfo:
                  "<h3>Nasjonale aktsomhetskart Jord-Flomskred</h3>Nasjonalt aktsomhetskartet som viser områder med potensiell fare for jord- og flomskred. Kartet er laget fra den landsdekkende høydemodellen med oppløsning på 10x10 meter. Denne glatter ut terrenget og små skrenter og terrasser i terrenget skjules. Det kan derfor være skredutsatte områder også utenfor aktsomhetssone. Mer informasjon om kartet finnes <a target='_blank' href=\" https://www.nve.no/naturfare/utredning-av-naturfare/om-kart-og-kartlegging-av-naturfare/om-kartlegging-av-skredfare-i-bratt-terreng/aktsomhetskart-for-jord-og-flomskred/\">hos Norges vassdrags- og energidirektorat <i class='icon-new-window'></i></a><br/><img src=\"https://nve.geodataonline.no/arcgis/services/SkredJordFlomAktR1/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Potensielt_Jord-Flomskredfare&format=image/png\">",
              },
              {
                olType: "tile",
                title: "Kommunal helningsanalyse med 5 meter filter",
                layerId: "skred5",
                url: parameters.kartlagtURL,
                layerName: "Helningsanalyse",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  "<h3>Kommunal helningsanalyse med 5 meter filter</h3>Kommunal helningsanalyse med 5 meter filter viser potensielle løsne- og utløpsområder for steinsprang i skråninger høyere enn 5 meter. Kartet er laget fra en kommunal høydemodell med oppløsning på 2x2 meter. </p><p>Mer informasjon om kartet finnes i <a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023037534&fileid=10694324\">faktaarket <i class='icon-new-window'></i></a><br /><br/><img src=\"" +
                  parameters.kartlagtURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Helningsanalyse&format=image/png">',
              },
              {
                olType: "tile",
                title: "Kartlegginger utført av fagkyndig konsulentfirma",
                layerId: "skred6",
                url: parameters.kartlagtURL,
                layerName: "Steinsprangkartlegging",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  "<h3>Kartlagte aktsomhetsområder for steinsprang i Oslo kommune</h3><p>Kartleggingen er utført av fagkyndige og resultatene er beskrevet i følgende rapporter:</p><ul><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2012086229&fileid=3679699\">NGI Rapport 20110386 «Planområde Gjersrud-Stensrud skredfarevurdering» <i class='icon-new-window'></i></a></li><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2013011690&fileid=3881006\">NGI Rapport 20110826 «Aktsomhetskartlegging for steinsprang i Oslo kommune» <i class='icon-new-window'></i></a>  (Sak 201009909) </li><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2013011690&fileid=3881007\">NGI Rapport 20110826 «Aktsomhetskartlegging for steinsprang i Oslo kommune» (revidert)<i class='icon-new-window'></i></a> (Sak 201009909) </li><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2013011645&fileid=3880875\">Multiconsult Rapport 20101221 «Utvalgte områder for vurdering av steinsprangfare» <i class='icon-new-window'></i></a>  (Sak 201009909) </li></ul><br /><br/><img src=\"" +
                  parameters.kartlagtURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Steinsprangkartlegging&format=image/png">',
              },
            ],
          },
          {
            olType: "tile",
            title: "Vannveier",
            layerId: "vann",
            url: parameters.vannBekkerEleverurl,
            layerName: "Vannflater,Vannlinjer",
            attribution: "©VAV",
            attributionId: "c-vav",
            layerInfo: true,
            visible: false,
            customLayerInfo: helptext.getInfoTextFor("vann"),
          },
          {
            olType: "group",
            layerId: "flom",
            title: "Flom i elver og bekker",
            layerInfo: false,
            collapsible: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "tile",
                title: "NVEs aktsomhetssoner for elveflom ",
                layerId: "elveflom",
                url: "https://nve.geodataonline.no/arcgis/services/FlomAktsomhet/MapServer/WmsServer?",
                layerName: "Flom_aktsomhetsomrade,MaksimalVannstandstigning",
                layerInfo: true,
                customLayerInfo:
                  '<h3>NVEs aktsomhetssoner for elveflom</h3>Nasjonalt aktsomhetskart som på oversiktsnivå viser hvilke arealer som kan være utsatt for flomfare fra vassdrag. Kartet er laget fra den landsdekkende høydemodellen med oppløsning på 10x10 meter og FKB - vann (grunnkartet). Mer informasjon om kartet finnes <a target=\'_blank\' href="https://www.nve.no/naturfare/utredning-av-naturfare/om-kart-og-kartlegging-av-naturfare/om-kartlegging-av-flaumfare/aktsomhetskart-for-flom/">hos Norges vassdrags- og energidirektorat <i class=\'icon-new-window\'></i></a><br /><img src="https://nve.geodataonline.no/arcgis/services/FlomAktsomhet/MapServer/WMSServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=MaksimalVannstandstigning&format=image/png"><br /><br /><img src="https://nve.geodataonline.no/arcgis/services/FlomAktsomhet/MapServer/WMSServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Flom_aktsomhetsomrade&format=image/png">',
                visible: false,
              },
              {
                olType: "tile",
                title: "Initial 1000-års flom for regulerte vassdrag",
                layerId: "initial",
                url: parameters.flomURL,
                layerName: "Initialflom",
                layerInfo: true,
                customLayerInfo:
                  '<h3>Initial 1000-års flom for regulerte vassdrag</h3>Initial 1000-års flom i de regulerte vassdragene Akerselva, Alna og Ljanselva. Dette er en grov beregning gjort i forbindelse med dambruddsbølgeberegninger.<br /><img src="' +
                  parameters.flomURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Initialflom&format=image/png">',
                visible: false,
              },
              {
                olType: "tile",
                title: "Flomsonekart fra NVE",
                layerId: "Flomsonekart",
                url: parameters.flomURL,
                layerName: "Flomsonekart",
                layerInfo: true,
                customLayerInfo:
                  "<h3>Flomsonekart fra NVE</h3>Rapporter fra NVE:<ul><li><a target='_blank' href=\"https://publikasjoner.nve.no/flomsonekart/2010/flomsonekart2010_06.pdf\">Flomsonekart for Sørkedalselva <i class='icon-new-window'></i></a></li><li><a target='_blank' href=\"https://publikasjoner.nve.no/flomsonekart/2010/flomsonekart2010_01.pdf\">Flomsonekart for Ellingsrudelva <i class='icon-new-window'></i></a></li></ul><br /><img src=\"" +
                  parameters.flomURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Flomsonekart&format=image/png">',
                visible: false,
              },
            ],
          },
          {
            olType: "group",
            layerId: "overvann",
            title: "Overvann",
            layerInfo: true,
            customLayerInfo:
              "<h3>Overvann</h3>Kartene viser resultater fra Oslo kommunes overvannsmodell og GIS-analyser. De utelukker ikke flomfare i andre områder, men er et godt utgangspunkt for videre undersøkelser. </p><p>Overvann skal håndteres i tråd med kommuneplanens bestemmelser pkt.24.1 og 24.2 og kommunens retningslinjer og veiledning for overvannshåndtering. ",
            collapsible: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "wmts",
                title: "Modellert vanndybde (D)",
                layerId: "mikedybde",
                url: parameters.mapcacheurl,
                layerName: "Mike_Dybde",
                layerInfo: true,
                customLayerInfo:
                  '<h3>Modellert vanndybde (D)</h3>Modellert vanndybde (D) viser maksimal vanndybde på oversvømt areal ved overvannsflom som følge av et styrtregn som statistisk sett inntreffer en gang per 100 år (100-års regnet). Ved etablering av kartgrunnlaget er det tatt hensyn til klimaendringer, dvs. kartet viser resultater fra klimajustert 100-års regn.<br /><br />Kartgrunnlaget er basert på resultater fra Oslos treveiskoblede hydrauliske overvannsmodell som simulerer både avrenning på terreng, i kommunalt ledningsnett og i vassdrag i en og samme modell.<br /><br />Kartet gir informasjon om arealer med risiko for skade som følge av oversvømmelse ved styrtregn. Fargelagte risikointervaller synliggjør hvor stor faren er. Intervallene er hentet fra NVEs <a target=\'_blank\' href="https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf">«Rettleiar for handtering av overvatn i arealplanar (4/22)» <i class=\'icon-new-window\'></i></a>, tabell 4-1. Kartet utelukker ikke oversvømmelsesfare i andre områder, men er et godt utgangspunkt for videre undersøkelser.<br/>Overvann skal håndteres i tråd med kommuneplanens bestemmelser pkt. 24.1 og 24.2 og kommunens <i>Retningslinjer og veiledning for overvannshåndtering</i>.<br /><br />Informasjon i kartet skal benyttes som underlag ved diverse utredninger, planlegging og prosjektering av overvannshåndtering knyttet til reguleringsplaner og byggesaker, og i forbindelse med risiko- og sårbarhetsanalyser (ROS-analyser) og konsekvensutredninger. I en byggesak skal du også dokumentere at den nye bebyggelsen er sikret i henhold til regelverket.<br /><br/>Kartet skal benyttes sammen med andre kart relatert til overvann, særlig med kartene <i>modellert dybdeintegrert hastighet (DV)</i>, <i>avrenningsmønster</i>, <i>avrenningslinjer</i> og <i>vannveier</i>. I tillegg er det naturlig å vurdere overvannsrelaterte farer sammen med flom i vassdrag, se temakart <i>Flom i elver og bekker</i>.<br /><br /><b>Her kan du lese mer</b><ul><li><span style="color:grey">Faktaark Overvannsmodellen (lenke kommer)</span></li><li>NVEs <a target=\'_blank\' href="https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf">«Rettleiar for handtering av overvatn i arealplanar (4/22)» <i class=\'icon-new-window\'></i></a></li><li><span style="color:grey">Retningslinjer og veiledning for overvannshåndtering (lenke kommer)</span></li><li><span style="color:grey">Kommuneplan arealdel (lenke kommer)</span></li></ul>',
                visible: false,
              },
              {
                olType: "wmts",
                title: "Modellert dybdeintegrert hastighet (DV)",
                layerId: "mikedv",
                url: parameters.mapcacheurl,
                layerName: "Mike_Avrenning",
                layerInfo: true,
                customLayerInfo:
                  "<h3>Modellert dybdeintegrert hastighet (DV)</h3>Modellert dybdeintegrert hastighet (DV)forteller oss hvor det er stor fare forårsaket av store vanndybder og/eller store vannhastigheter ved overvannsflom som følge av et styrtregn som statistisk sett inntreffer en gang per 100 år (100-års regnet). Ved etablering av kartgrunnlaget er det tatt hensyn til klimaendringer, dvs. kartet viser resultater fra klimajustert 100-års regn.<br /><br />Kartgrunnlaget er basert på resultater fra Oslos treveiskoblede hydrauliske overvannsmodell som simulerer både avrenning på terreng, i kommunalt ledningsnett og i vassdrag i en og samme modell.<br /><br />DV beregnes som D x V, altså dybde gange hastighet. Der DV er stor, kan gjenstander og mennesker i gaten bli revet med vannstrømmen og vannmassene kan føre til erosjon. Kartet gir informasjon om hvor forventes det fare for DV-relatert risiko for skade ved styrtregn. Fargelagte risikointervaller synliggjør hvor stor faren er. Intervallene er hentet fra NVEs <a target='_blank' href=\"https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf\">«Rettleiar for handtering av overvatn i arealplanar (4/22)» <i class='icon-new-window'></i></a>, tabell 4-1. Kartet utelukker ikke fare i andre områder, men er et godt utgangspunkt for videre undersøkelser.<br/>Overvann skal håndteres i tråd med kommuneplanens bestemmelser pkt. 24.1 og 24.2 og kommunens <i>Retningslinjer og veiledning for overvannshåndtering</i>.<br /><br />Informasjonen i kartet skal benyttes som underlag ved diverse utredninger, planlegging og prosjektering av overvannshåndtering knyttet til reguleringsplaner og byggesaker, og i forbindelse med risiko- og sårbarhetsanalyser (ROS-analyser) og konsekvensutredninger. I en byggesak skal du også dokumentere at den nye bebyggelsen er sikret i henhold til regelverket.<br /><br />Kartet skal benyttes sammen med andre kart relatert til overvann, særlig med kartene <i>modellert dybde (D)</i>, <i>avrenningsmønster</i>, <i>avrenningslinjer</i> og <i>vannveier</i>. I tillegg er det naturlig å vurdere overvannsrelaterte farer sammen med flom i vassdrag, se temakart <i>Flom i elver og bekker</i>.",
                visible: false,
              },
              {
                olType: "tile",
                title: "Vannveier2",
                layerId: "vann2",
                displayInLayerMenu: false,
                url: parameters.vannBekkerEleverurl,
                layerName: "Vannflater,Vannlinjer",
                attribution: "©VAV",
                attributionId: "c-vav",
                layerInfo: false,
                visible: false,
              },
              {
                olType: "tile",
                title: "Vannveier3",
                layerId: "vann3",
                displayInLayerMenu: false,
                url: parameters.vannBekkerEleverurl,
                layerName: "Vannflater,Vannlinjer",
                attribution: "©VAV",
                attributionId: "c-vav",
                layerInfo: false,
                visible: false,
              },
              {
                olType: "wmts",
                title: "Avrenningsmønster",
                layerId: "avrenning",
                url: parameters.mapcacheurl,
                layerName: "avrenning",
                altSource: {
                  url: parameters.avrenningURL,
                  layerName: "avrenningsmønster",
                },
                layerInfo: true,
                customLayerInfo:
                  "<h3>Avrenningsmønster</h3><p>Avrenningsmønsteret er en samling av mange avrenningslinjer (tidl. kalt dreneringslinjer). Mønsteret simulerer hvordan avrenningslinjene kan påvirkes av unøyaktigheter i terrengmodellen, ujevnheter i terrenget og ulik vannhastighet og dybde. Det viser at overvann kan ta flere veier, ikke bare den bratteste. Avrenningsmønsteret viser derfor usikkerheten knyttet til hver avrenningslinje. Mørk farge betyr at mange avrenningslinjer med stort nedslagsfelt sammenfaller.<br /><br />Overvann skal håndteres i tråd med kommuneplanens bestemmelser pkt. 24.1 og 24.2 og kommunens <i>Retningslinjer og veiledning for overvannshåndtering.</i><br /><br />Dette kartet skal brukes sammen med de andre overvannskartene for å få oversikt over hva man kan forvente i forhold til overvann i området.<br /><br /><b>Her kan du lese mer</b><ul><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023088702&fileid=10883926\">Faktaark om avrenningslinjer og avrenningsmønster <i class='icon-new-window'></i></a></li><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023088702&fileid=10883952\">Artikkel om avrenningsmønster i Vann 02 2023 <i class='icon-new-window'></i></a></li><li>NVEs <a target='_blank' href=\"https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf\">«Rettleiar for handtering av overvatn i arealplanar (4/22)» <i class='icon-new-window'></i></a></li><li><span style=\"color:grey\">Retningslinjer og veiledning for overvannshåndtering (lenke kommer)</span></li><li><span style=\"color:grey\">Kommuneplan arealdel (lenke kommer)</span></li></ul>",
                visible: false,
                dependent: "vann2",
              },
              {
                olType: "tile",
                title: "Avrenningslinjer (Dreneringslinjer)",
                layerId: "drenering",
                url: parameters.avrenningURL,
                layerName: "Dreneringslinjer",
                layerInfo: true,
                /*Denne overstyrer info som ligger et annet sted*/
                customLayerInfo:
                  "<h3>Avrenningslinjer (Dreneringslinjer)</h3>Kartet avrenningslinjer (tidligere kalt dreneringslinjer) viser resultater fra en enkel matematisk beregning av hvor overvann vil renne fra høyereliggende til lavereliggende arealer basert på terrengform og helning. Det tar ikke hensyn til vannmengder, overflater, rørsystem og infiltrasjon. Dette kan derfor sees på som en beregning av hvor det er sannsynlig at vannet vil renne dersom kulverter, stikkrenner og rørsystem er utilgjengelig.<br /><br />Overvann skal håndteres i tråd med kommuneplanens bestemmelser pkt. 24.1 og 24.2 og kommunens <i>Retningslinjer og veiledning for overvannshåndtering</i>.<br /><br />Dette kartet skal brukes sammen med de andre overvannskartene for å få oversikt over hva man kan forvente i forhold til overvann i området.<br /><br /><b>Her kan du lese mer</b><ul><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023088702&fileid=10883926\">Faktaark om avrenningslinjer og avrenningsmønster <i class='icon-new-window'></i></a></li><li>NVEs <a target='_blank' href=\"https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf\">«Rettleiar for handtering av overvatn i arealplanar (4/22)» <i class='icon-new-window'></i></a></li><li><span style=\"color:grey\">Retningslinjer og veiledning for overvannshåndtering (lenke kommer)</span></li><li><span style=\"color:grey\">Kommuneplan arealdel (lenke kommer)</span></li></ul>",
                visible: false,
                dependent: "vann3",
              },
              /*{
							olType: "image",
							title: "Groper med dybde",
							layerId: "Groper",
							url:  parameters.avrenningURL,
							layerName: "Groper_m_dybde",
							layerInfo: true,
							customLayerInfo: "<h3>Groper med dybde</h3>Groper viser hvor det samles vann når det regner mye. ",
							visible: false
						}, {
							olType: "image",
							title: "Terrenghull",
							layerId: "Terrenghull",
							url:  parameters.avrenningURL,
							layerName: "Terrenghull",
							layerInfo: true,
							customLayerInfo: "<h3>Terrenghull</h3>Terrenghull viser punkter der tilhørende groper er så store at vann ikke vil renne videre ved regn.<br/><img src=\"" + parameters.avrenningURL + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Terrenghull&format=image/png\">" ,
							visible: false
						},*/ {
                olType: "image",
                title: "Overvannsrør med direkte utløp til sjø og vassdrag",
                layerId: "Overvannsror",
                url: parameters.avrenningURL,
                layerName: "Overvannsrør",
                layerInfo: true,
                customLayerInfo:
                  '<h3>Overvannsrør til sjø og vassdrag</h3>Overvannsrør nærmere enn 250 meter fra sjø eller vassdrag  hvor overvann kan slippes på uten fordrøyning dersom vilkår i retningslinjer og veiledning for overvannshåndtering i Oslo  er oppfylt.<br/><br/><img src="' +
                  parameters.avrenningURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Overvannsrør&format=image/png">',
                visible: false,
              },
            ],
          },
          {
            olType: "image",
            title: "Luftsonekart",
            layerId: "Luftsonekart",
            url: parameters.luftsone,
            layerName: "Luftsonekart",
            layerInfo: true,
            customLayerInfo:
              "<h3>Luftsonekart for Oslo kommune</h3>Kartet viser beregnet luftforurensning i tråd med statlig retningslinje for behandling av luftkvalitet i arealplanlegging (T-1520). Beregningene er basert på utslippsdata for forurensningskilder som blant annet veitrafikk og for gjennomsnittlig værforhold i en femårsperiode (2020–2024). Kartet representerer en sammenstilling av forurensingskomponentene i T-1520, nemlig svevestøv (PM<sub>10</sub>) og nitrogendioksid (NO<sub>2</sub>). <br /><br />Kilde: <a target='_blank' href=\"https://www.miljodirektoratet.no/tjenester/fagbrukertjeneste-for-luftkvalitet/?underside=luftsonekart\">Miljødirektoratet, Fagbrukertjeneste for luftkvalitet<i class='icon-new-window'></i></a>",
            visible: false,
          },
        ],
      },
      {
        olType: "group",
        layerId: "kartdetaljer",
        title: "Detaljer",
        collapsible: true,
        groupCheckbox: false,
        altTarget: "fkb",
        layers: [
          {
            olType: "wmts",
            title: "Bygninger, veier, koter m.m.",
            layerId: "situasjon",
            url: parameters.mapcacheurl,
            layerName: "bakgrunn_linjer",
            altSource: {
              url: parameters.ki_forgrunnurl,
              layerName: "Forgrunn",
              epsg: "EPSG:32632",
            },
            dependent: "tiltaksflate",
            noToggle: true,
            visible: true,
          },
          {
            olType: "image",
            title: "Gatenavn, adresser, m.m.",
            layerId: "text1",
            url: parameters.ki_forgrunnurl,
            layerName: "forgrunn_tekst",
            zIndex: 100,
            conditional: { condition: "flyfoto", trigger: "text2" },
            noToggle: true,
            visible: true,
          },
          {
            olType: "group",
            layerId: "eiendomsgrenser",
            title: "Eiendomsgrenser",
            collapsible: true,
            layerInfo: true,
            customLayerInfo:
              "<h3>Eiendomsgrenser</h3><br /><h4>Tegnforklaring:</h4><div class='legend-row'><div class='legend-symb legend-symb-line legend-eiendomsgrenser-landmaalt'>&nbsp;</div><div class='legend-text'>Landmålt grense</div></div><div class='legend-row'><div class='legend-symb legend-symb-line legend-seksjonsgrense'>&nbsp;</div><div class='legend-text'>Seksjonsgrense</div></div><div class='legend-row'><div class='legend-symb legend-anleggseiendommer'>&nbsp;</div><div class='legend-text'>Anleggseiendom</div></div><div class='legend-row'><div class='legend-symb legend-symb-line legend-eiendomsgrenser-usikker'>&nbsp;</div><div class='legend-text'>Ikke landmålt/usikker grense</div></div>",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "wmts",
                title: "Eiendomsgrenser",
                layerId: "eiendom",
                layerInfo: false,
                url: parameters.mapcacheurl,
                layerName: "eiendom",
                altSource: {
                  url: parameters.kartinnsynurl,
                  layerName: "Eiendom_piv5",
                  epsg: "EPSG:32632",
                },
                visible: false,
              },
              {
                olType: "image",
                layerId: "eiendomText",
                title: "eiendomsText",
                url: parameters.kartinnsynurl,
                layerName: [
                  "Fkb_eiendom_tekst_piv5",
                  "Fkb_eiendom_informasjonspil_piv5",
                ],
                zIndex: 100,
                dependent: "eiendom",
                displayInLayerMenu: false,
                visible: false,
              },
              {
                olType: "image",
                title: "Anleggseiendommer",
                layerId: "Anleggseiendom",
                layerInfo: false,
                url: parameters.kartinnsynurl,
                layerName: "Anleggseiendom",
                altSource: {
                  url: parameters.kartinnsynurl,
                  layerName: "Eiendom_piv5",
                  epsg: "EPSG:32632",
                },
                visible: false,
              },
            ],
          },
          {
            olType: "image",
            title: "Bydel",
            layerId: "bydel",
            url: parameters.kartinnsynurl,
            layerName: "Bydelsgrenser",
            visible: false,
          },
        ],
      },
    ],
    fkbLayers: false,
    //quickSearch: true,//Legger til hurtigvalgsmeny på toppen av kartlagsmenyen. Modes under med displayname vises i nedtreksmenyen.
    modes: [
      { mode: "saksinnsyn", displayName: "Saksinnsyn", layers: ["byggesak"] },
      { mode: "kommuneplan", displayName: "Kommuneplan", layers: ["kp"] },
      { mode: "kpt1", layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_stoy"] },
      {
        mode: "kpt2",
        layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_luftforurensing_t2"],
      },
      {
        mode: "kpt3",
        layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_luftforurensing_t3"],
      },
      {
        mode: "kpt4",
        layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_naturmiljo"],
      },
      {
        mode: "kpt5",
        layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_kulturminnevern"],
      },
      {
        mode: "kpt6",
        layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_storulykke"],
      },
      {
        mode: "kpt7",
        layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_blaagronn_struktur"],
      },
      { mode: "kp2-2", layers: ["kp", "kp_pk1_2", "kp_pk2_2"] },
      { mode: "gulliste", displayName: "Gul liste", layers: ["gulliste"] },
      { mode: "drenering", displayName: "Drenering", layers: ["drenering"] },
      {
        mode: "smahusplanen",
        displayName: "Småhusplanen",
        layers: ["smahusplanen"],
      },
      { mode: "vann", displayName: "Vann", layers: ["vann"] },
      { mode: "kdp", displayName: "Kommunedelplaner", layers: ["kdp"] },
      { mode: "eiendom", displayName: "Eiendom", layers: ["eiendom"] },
      {
        mode: "blagronn",
        displayName: "Blågrønn faktor",
        layers: ["blagronn_faktor", "eiendom"],
      },
      {
        mode: "planprogramogvpor",
        displayName: "Planprogram og vpor",
        layers: [
          "planprogram",
          "vpor",
          "vporpaagaaende",
          "planprogrampaagaaende",
        ],
      },
      { mode: "reklame", displayName: "Reklame", layers: ["reklameomrader"] },
      {
        mode: "mft",
        displayName: "Midlertidig forbud mot tiltak.",
        layers: ["MFT"],
      },
      {
        mode: "forurensetgrunn",
        displayName: "Forurenset grunn",
        layers: ["forurenset_grunn"],
      },
    ],
    search: {
      autocompleteUrl: parameters.autocompleteUrl,
      autocompleteHandlers: [
        { key: "gate", func: "lookupAdresserForGate" },
        { key: "plan", func: "getLookupPlan" },
        { key: "stedsnavn", func: "getLookupStedsnavn" },
      ],
      ariaLabel:
        "Skriv inn adresse, gårds- og bruksnummer, plannummer eller saksnummer",
      placeholder: "Søk på adresse, gnr./bnr.",
    },
    mapInteractions: {
      featureHover: true,
      featureClick: true,
    },
    contextMenu: {
      active: true,
      title1: "Om valgt eiendom",
      title2: "Om valgt punkt",
      mode: {
        top: true,
        area: true,
        point: true,
        /*bottom: "Hva vil du gjøre?",*/
      },
      headerField: {},
      bottomField: {},
      //Felter til kontekstmenyen.
      fields: [
        {
          id: "planerParent",
          title: "Planer",
          point: true,
          fields: [
            {
              id: "kommuneplan",
              title: "Kommuneplan 2015",
              point: true,
            },
            {
              id: "kommuneplanNY",
              title: "Kommuneplan (forslag)",
              point: true,
            } /* {							
						id: "kdp",
						title: "Kommunedelplan",
						point: true,
						featureCount: true
					}, {
						id: "omrreg",
						title: "Områderegulering",
						point: true,
						featureCount: true
					}, {
						id: "planer",
						title: "Reguleringsplaner",
						point: true,
						featureCount: true
					}, {
						id: "reklame",
						title: "Skilt- og reklameplan",
						point: true,
						featureCount: true
					}, {
						id: "planprogram",
						title: "Planprogrammer",
						point: true,
						featureCount: true
					}, {
						id: "vpor",
						title: "VPOR",
						subTitle: "Veiledende plan for offentlig rom",
						point: true,
						featureCount: true
					}, {
						id: "hovinbyen",
						title: "Strategisk plan for Hovinbyen",
						point: true,
						featureCount: true
					},{
						id: "kunngj",
						title: "Plankunngjøringer",
						point: true,
						featureCount: true
					}, {
						id: "mft",
						title: "Midlertidig forbud mot tiltak",
						point: true,
						featureCount: true
					}*/,
            ,
          ],
        } /* {
				id: "sakerParent",
				title: "Saker",
				subTitle: "Her finner du alle sakene på eiendommen",
				point: false,
				fields: [
					{
						id: "saker",
						title: "Byggesaker",
						point: false,
						featureCount: true
					}, {
						id: "plansaker",
						title: "Plansaker",
						point: false,
						featureCount: true
					}, {
						id: "delesaker",
						title: "Eiendomssaker",
						point: false,
						featureCount: true
					},
				],
			},*/ /* {
				id: "temakart",
				title: "Temakart",
				point: true,
				fields: [
					{
						id: "gulliste",
						title: "Gul liste",
						point: true,
						featureCount: true
					}, {
						id: "funnpot",
						title: "Fortidsminner",
						subTitle: "Sannsynlighet for funn",
						point: true,
						featureCount: true
					}, {
						id: "naturmangfold",
						title: "Naturmangfold",
						point: true,
						featureCount: true
					}, {
						id: "forurensetgrunn",
						title: "Forurenset grunn",
						point: true,
						featureCount: true
					}, {
						id: "vann",
						title: "Vann, bekker og elver",
						point: true,
						featureCount: true
					}, {
						id: "fjernvarme",
						title: "Konsesjonsområde for fjernvarme",
						point: true,
						featureCount: true
					}, {
						id: "maringrense",
						title: "Marin grense",
						point: true,
						featureCount: true
					}, {
						id: "dreneringslinjer",
						title: "Dreneringslinjer",
						point: true,
						featureCount: true
					}, {
						id: "veitype",
						title: "Veitype",
						point: true,
						featureCount: true
					}, {
						id: "fartsgrenser",
						title: "Fartsgrenser",
						point: true,
						featureCount: true
					}, {
						id: "trafikkmengde",
						title: "Trafikkmengde",
						point: true,
						featureCount: true
					}, {
						id: "blaagronn",
						title: "Blågrønn faktor",
						point: true,
						featureCount: true
					}, {
						id: "friluftsliv",
						title: "Friluftslivsområder",
						point: true,
						featureCount: true
					}
				],
			}*/,
        ,
      ],
      //Layout og innlasting av data til kontekstmeny.
      //Targets id korresponderer med felter over.
      //Extendedinfo gir layout for nivå 2 ved klikk i menyen.
      loaders: [
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "regis.kpinfo_oppslag2",
          table: "regis.kpinfo_oppslag2",
          typeNames: ["eiendom_polygon", "eiendom_linje", "eiendom_punkt"],
          filterItem: ["teigid"],
          targets: [
            {
              id: "kommuneplanNY",
              layerId: "kpny",
              showExtendedInfo: true,
              comparator: "header",
              sort: function (sort1, sort2) {
                if (sort1.get("TEMAGRUPPEKODE") > sort2.get("TEMAGRUPPEKODE"))
                  return 1;
                if (sort1.get("TEMAGRUPPEKODE") < sort2.get("TEMAGRUPPEKODE"))
                  return -1;
              },
              layout: [
                { type: "header", value: "header", unique: true },
                { type: "layerCheckbox", tekst: "Vis i kartet", unique: true },
                //{type: "legendFeature", legendValue: "legendValues", labelValue: "labelValues", hover: true, triggerField: true},
                {
                  type: "conditional",
                  notEmptyCondition: "tester",
                  exist: {
                    type: "legendFeature",
                    legendValue: "legendValues",
                    labelValue: "{0}",
                    hover: true,
                    triggerField: true,
                  },
                  "": {
                    type: "legendFeature",
                    legendValue: "legendValues",
                    labelValue: "{0}",
                    hover: true,
                    triggerField: false,
                  },
                },
              ],
              values: {
                legendValues: ["KODE"],
                labelValues: ["KODE_TEKST"],
                header: "TEMAGRUPPE",
                layerCheckbox: "TEMAGRUPPEKODE",
                comparator: "KODE_TEKST",
                counter: "KODE",
                key: "KODE",
                tester: "OM_BESK",
              },
              extendedInfo: {
                //header: "Kommuneplan",
                //internal: "./kp_extended_info",
                layout: [
                  { type: "header4", value: "LABEL" }, // går det an å få denne teksten større?
                  {
                    type: "paragraph",
                    prefix: "<strong>Beskrivelse</strong><br />",
                    value: "OM_BESK",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Begrunnelse</strong><br />",
                    value: "OM_BEGR",
                  },
                ],
              },
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.geoJsonWFS + parameters.wfsTillegg,
          typeNames: ["kpinfo_for_eiendom"],
          filterItem: ["teigid"],
          targets: [
            {
              id: "kommuneplan",
              layerId: "kp",
              showExtendedInfo: false,
              merInfoLink: "Mer info om kommuneplanen",
              merInfoLayout: [
                { type: "header", value: "Kommuneplan" },
                {
                  type: "paragraph",
                  value: "<strong>Arealplanid</strong><br />-",
                },
                {
                  type: "paragraph",
                  value: "<strong>Plantype</strong><br />Kommuneplan",
                },
                {
                  type: "paragraph",
                  value: "<strong>Planstatus</strong><br />Vedtatt",
                },
                {
                  type: "paragraph",
                  value:
                    "<strong>Planbestemmelse</strong><br />Se plandokument",
                },
                {
                  type: "paragraph",
                  value: "<strong>Lovreferanse</strong><br />PBL 2008",
                },
                {
                  type: "paragraph",
                  value: "<strong>Ikraftsettelsesdato</strong><br />23.09.2015",
                },
                {
                  type: "paragraph",
                  value:
                    "<strong>Plannavn</strong><br />Oslo mot 2030 – Smart, trygg og grønn",
                },
                {
                  type: "paragraph",
                  value:
                    "<strong>Vedtak endelig plandato</strong><br />23.09.2015",
                },
                {
                  type: "paragraph",
                  value: "<strong>Kunngjøringsdato</strong><br />23.09.2015",
                },
                {
                  type: "link",
                  url: "https://www.oslo.kommune.no/politikk-og-administrasjon/politikk/kommuneplan/kommuneplan-2015/",
                  text: "Kommuneplan - oversiktside",
                },
                {
                  type: "link",
                  url: "https://www.oslo.kommune.no/getfile.php/1374702/Innhold/Politikk%20og%20administrasjon/Politikk/Kommuneplan/Ny%20kommuneplan%202015/Kommuneplan%202015%20del%202%20justert%2031.01.2017.pdf",
                  text: "Plandokument - juridisk arealdel",
                },
                {
                  type: "link",
                  url: "https://tjenester.oslo.kommune.no/ekstern/einnsyn/moeteregistrering/http%3A%2F%2Fdata.einnsyn.no%2Fnoark5%2Fmoeteregistrering--MR-1029939-1400416-1044894-262--976819853",
                  text: "Vis sak i eInnsyn (innsyn i politiske saker)",
                },
              ],
              comparator: "header",
              sort: function (sort1, sort2) {
                if (sort1.get("TEMAGRUPPEKODE") > sort2.get("TEMAGRUPPEKODE"))
                  return 1;
                if (sort1.get("TEMAGRUPPEKODE") < sort2.get("TEMAGRUPPEKODE"))
                  return -1;
              },
              layout: [
                { type: "header", value: "header", unique: true },
                { type: "layerCheckbox", tekst: "Vis i kartet", unique: true },
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  labelValue: "{0}",
                  hover: true,
                  triggerField: true,
                },
              ],
              values: {
                legendValues: ["KODE"],
                labelValues: ["KODE_TEKST"],
                header: "TEMAGRUPPE",
                layerCheckbox: "TEMAGRUPPEKODE",
                comparator: "TEMAGRUPPE",
                counter: "KODE",
                key: "KODE",
              },
              extendedInfo: {
                //	header: "Kommuneplan",
                //	internal: "./kp_extended_info",
              },
            },
          ],
        },
      ],
      dyplenker: [
        // url må inneholde @(gnr) og @(bnr) som byttes ut med gnr og bnr for eiendommen det klikkes på
        /* {
				innerHTML: "Reguleringsplott for valgt eiendom",
				url: "http://10.192.10.26/xkart/plott/index.html?gnr=@(gnr)&bnr=@(bnr)"
			}, {
				innerHTML: "Hva gjelder for eiendommen",
				url: "https://tjenester.oslo.kommune.no/ekstern/veiledere/eiendomsinfo/#/?gnr=@(gnr)&bnr=@(bnr) "
			}, {
				innerHTML: "Se grunnforhold i Oslo",
				url: "http://10.192.10.26/xkart/grunnforhold"
			}*/
      ],
      //Layout for klikk på features i kartet.
      //Info kommer fra WFS
      featureClickLayout: {
        vpor: {
          header: "VPOR",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "header", value: "T1" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        vporpaagaaende: {
          header: "VPOR",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        hovinbyenF: {
          header: "Strategisk plan for Hovinbyen",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        hovinbyen_a: {
          header: "Strategisk plan for Hovinbyen",
          layout: [
            { type: "header", value: "NAVN" },
            { type: "paragraph", value: "TEKST" },
            {
              type: "link",
              url: "https://od2.pbe.oslo.kommune.no/pages/vedlegg/Aksene Hovinbyen - samlet.pdf#page=",
              urlParam: "PAGE",
              text: "LENKETEKST",
            },
            {
              type: "link",
              url: "https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2020010672&fileid=9127592",
              text: "«Strategisk plan for Hovinbyen»",
            },
          ],
        },
        MFT: {
          header: "Midlertidig forbud mot tiltak",
          layout: [
            { type: "header", value: "T" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "S",
              text: "Vis i Saksinnsyn",
            },
          ],
        },
        detaljregulering: {
          header: "Pågående plansak",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Saksnr</strong><br />",
              value: "S",
            },
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "T",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "PLANTYPESTR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "INSTANS",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "LOVREF",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vertikalnivå</strong><br />",
              value: "VERTNIV",
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "MERKNAD",
              alt: "-",
            },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "S",
              text: "Se plansak",
            },
          ],
        },
        smahusplanen: {
          header: "Pågående plansak",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Saksnr</strong><br />",
              value: "S",
            },
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "T",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "PLANTYPESTR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "INSTANS",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "LOVREF",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vertikalnivå</strong><br />",
              value: "VERTNIV",
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "MERKNAD",
              alt: "-",
            },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "S",
              text: "Se plansak",
            },
          ],
        },
        omraaderegulering: {
          header: "Pågående plansak",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Saksnr</strong><br />",
              value: "S",
            },
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "T",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "PLANTYPESTR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "INSTANS",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "LOVREF",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vertikalnivå</strong><br />",
              value: "VERTNIV",
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "MERKNAD",
              alt: "-",
            },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "S",
              text: "Se plansak",
            },
          ],
        },
        omreg: {
          header: "navn",
          external: true,
          url: parameters.planmetaWSUrl + "plannavn=",
          urlKey: "PLANNAVN",
          layout: [
            //{type: "paragraph", prefix: "<strong>Saksnr</strong><br />", value: "S"},
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "tittel",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "typedef",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "vedtaksdato",
              alt: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "instans",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "lovref",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "href",
              alt: "-",
            },
            {
              type: "conditional",
              condition: "vertniv",
              1: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "Under bakken",
              },
              2: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "På bakkenivå",
              },
              3: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "Over bakken",
              },
              4: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "På havbunnen",
              },
              5: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "I vannsøylen",
              },
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "merknad",
              alt: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Arkiv</strong><br />",
              value: "arkiv",
              alt: "-",
            },
            {
              type: "conditional",
              condition: "type",
              30: {
                type: "link",
                url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                urlParam: ["vedtaksaar", "navn"],
                postfix: ".pdf",
                text: "Reguleringsbestemmelser",
              },
              21: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                text: "Plandokument",
              },
              0: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                text: "Se plansak",
              },
              "": {
                type: "link",
                url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                urlParam: ["vedtaksaar", "navn"],
                postfix: ".pdf",
                text: "Reguleringsbestemmelser",
              },
            },
            {
              type: "conditional",
              condition: "dok",
              0: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                text: "Vis plansak",
              },
              1: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
              "": {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
            },
            {
              type: "multi",
              value: "koblinger",
              header: {
                type: "paragraph",
                value: "<strong>Knytninger til andre planer</strong><br />",
              },
              layout: {
                type: "div",
                children: [
                  { type: "span", value: "type", postfix: ":" },
                  {
                    type: "button",
                    value: "navn",
                    classname: "btn btn-link",
                    clickfunction: function (
                      plannavn,
                      target,
                      privateFns,
                      config,
                    ) {
                      var url =
                        parameters.planmetaWSUrl + "plannavn=" + plannavn;
                      $.ajax({
                        url: url,
                        success: function (response) {
                          let contents = target.children().detach();
                          target.append(
                            privateFns.createExtendedInfoSection(
                              config,
                              config,
                              response,
                              contents,
                              target,
                            ),
                          );
                        },
                        fail: function () {
                          console.error("fail");
                        },
                        error: function () {
                          console.error("error");
                        },
                      });
                    },
                  },
                ],
              },
            },
          ],
        },
        planprogram: {
          header: "Planprogram",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "header", value: "T1" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        planprogrampaagaaende: {
          header: "Planprogram",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        kunngjoringer: {
          header: "Plankunngjøring",
          layout: [
            { type: "paragraph", value: "T" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B1",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B2" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B3",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B4" },
            {
              type: "link",
              url: parameters.sidinmeningUrl + "?idnr=",
              urlParam: "ID",
              text: "Vis kunngjøringen og si din mening",
            },
          ],
        },
        byggesak: {
          cssClass: "feature-info-element element-box",
          layout: [
            { type: "paragraph", value: "T" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B1",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B2" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B3",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B4" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "B2",
              text: "Vis i Saksinnsyn",
            },
          ],
        },
        eiendomssak: {
          cssClass: "feature-info-element element-box",
          layout: [
            { type: "paragraph", value: "T" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B1",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B2" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B3",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B4" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "B2",
              text: "Vis i Saksinnsyn",
            },
          ],
        },
        postliste: {
          cssClass: "feature-info-element element-box",
          layout: [
            { type: "paragraph", value: "T" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B1",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B2" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B3",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B4" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "B2",
              text: "Vis i Saksinnsyn",
            },
          ],
        },
        trafikkmengde: {
          header: "Trafikkmengde",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Gjelder for år: </strong>",
              value: "AAR_GJELDER_FOR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Årsdøgntrafikk (ÅDT):</strong>",
              value: "AADT_TOTAL",
              suffix: "</strong><br/>",
            },
            {
              type: "paragraph",
              value:
                "ÅDT er gjennomsnittlig døgntrafikk i løpet av et år og er mål for trafikkmengden. ÅDT beregnes som antall kjøretøy som passerer et snitt på en vei (for begge retninger sammenlagt) i løpet av et år, dividert med 365.",
            },
            {
              type: "paragraph",
              value:
                "Dataene er hentet fra Norsk vegdatabank (NVDB) som driftes av Statens vegvesen og har informasjon om trafikkmengde på statlige og kommunale veier og gater. NVDB er normalt en pålitelig kilde for trafikkmengde på riksveinettet, men trafikkmengden på det kommunale veinettet oppdateres bare uregelmessig.",
            },
          ],
        },
        regPlan: {
          header: "navn",
          modify: function (plan) {
            if (plan.dok && plan.dok > 1) {
              plan.dok = 1;
            }
            return plan;
          },
          layout: [
            //{type: "paragraph", prefix: "<strong>Saksnr</strong><br />", value: "S"},
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "tittel",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "typedef",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "vedtaksdato",
              alt: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "instans",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "lovref",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "href",
              alt: "-",
            },
            {
              type: "conditional",
              condition: "vertniv",
              1: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "Under bakken",
              },
              2: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "På bakkenivå",
              },
              3: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "Over bakken",
              },
              4: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "På havbunnen",
              },
              5: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "I vannsøylen",
              },
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "merknad",
              alt: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Arkiv</strong><br />",
              value: "arkiv",
              alt: "-",
            },
            {
              type: "conditional",
              condition: "type",
              35: {
                type: "link",
                url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                urlParam: ["vedtaksaar", "navn"],
                postfix: ".pdf",
                text: "Reguleringsbestemmelser",
                addCondition: "vedtaksdato",
              },
              30: {
                type: "link",
                url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                urlParam: ["vedtaksaar", "navn"],
                postfix: ".pdf",
                text: "Reguleringsbestemmelser",
                addCondition: "vedtaksdato",
              },
              21: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                text: "Plandokument",
              },
              0: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                text: "Se plansak",
              },
              "": {
                type: "link",
                url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                urlParam: ["vedtaksaar", "navn"],
                postfix: ".pdf",
                text: "Reguleringsbestemmelser",
                addCondition: "vedtaksdato",
              },
            },
            {
              type: "conditional",
              condition: "dok",
              0: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                text: "Vis plansak",
              },
              1: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
              "": {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
              undefined: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
            },
            {
              type: "multi",
              value: "koblinger",
              header: {
                type: "paragraph",
                value: "<strong>Knytninger til andre planer</strong><br />",
              },
              layout: {
                type: "div",
                children: [
                  { type: "span", value: "type", postfix: ":" },
                  {
                    type: "button",
                    value: "navn",
                    classname: "btn btn-link",
                    clickfunction: function (
                      plannavn,
                      target,
                      privateFns,
                      config,
                    ) {
                      var url =
                        parameters.planmetaWSUrl + "plannavn=" + plannavn;
                      $.ajax({
                        url: url,
                        success: function (response) {
                          let contents = target.children().detach();
                          target.append(
                            privateFns.createExtendedInfoSection(
                              config,
                              config,
                              response,
                              contents,
                              target,
                            ),
                          );
                        },
                        fail: function () {
                          console.error("fail");
                        },
                        error: function () {
                          console.error("error");
                        },
                      });
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    },
    //Tipsboks. TipId settes som cookie for å ikke vise boksen igjen.
    activeTip: false,
    tipText:
      "Her kommer det noe vettug tekst, kanskje<br /><br /> Klikk i kartet og se under «Kommuneplan 2024» for å få mer informasjon om kartobjektene",
    tipId: "testWarning",
  }));

// Legg til ekstra css-filer
//$("head").append("<link rel='stylesheet' type='text/css' href='css/foo.css'>");

//Titlelink setter lenke for oslologo + planinnsyn. Går til seg selv hvis den ikke er satt.
export default {
  intranett: true,
  site: {
    title: " |&nbsp;&nbsp; Høringsforslag kommuneplan",
    titleLink: "",
  },
  loadplugins: function (map, callback) {
    attribution.initiate({
      parent: "footerId",
      id: "copy-pbe",
      text: "©Oslo PBE",
      aria: "vis informasjon om vilkår for bruk av tjenesten",
      article:
        " <p>Plan- og bygningsetaten ønsker å levere data av høy kvalitet, men kan ikke garantere at innholdet i tjenesten er uten feil og mangler.</p> <p>Et reguleringsplankart er en sammenstilling av alle planforslag og gjeldende reguleringsplaner, og sammenstillingen er ikke juridisk bindende.</p> <p>Kart og eiendomsinformasjon er beskyttet etter åndsverkloven.</p>",
    });
    layermenu.initiate(configs.layermenuLayers, "Velg kartlag");
    baselayerSwitcher.initiate(
      document.getElementById("mapmenu"),
      map,
      "bakgrunn",
      "flyfoto",
      "./img/bakgrunnskart.min.png",
      "./img/flyfoto.min.jpg",
    );
    searchPlugin.initiate(configs.search);
    contextPlugin.initiate(configs);
    topMenuPlugin.initiate(configs.topMenu, parameters.intranett);
    callback();
  },
  customClickTriggers: [],
  parameters: parameters,
  configs: configs,
};
